var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAvatar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "402px",
    height: "990px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1a2023",
    d: "M -0.5,-0.5 C 131.833,-0.5 264.167,-0.5 396.5,-0.5C 396.5,189.167 396.5,378.833 396.5,568.5C 274.5,568.5 152.5,568.5 30.5,568.5C 29.8333,287.167 29.1667,287.167 28.5,568.5C 18.8333,568.5 9.16667,568.5 -0.5,568.5C -0.5,378.833 -0.5,189.167 -0.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#0f1415",
    d: "M 396.5,-0.5 C 397.167,-0.5 397.833,-0.5 398.5,-0.5C 398.5,329.5 398.5,659.5 398.5,989.5C 397.833,989.5 397.167,989.5 396.5,989.5C 396.5,866.833 396.5,744.167 396.5,621.5C 396.5,603.833 396.5,586.167 396.5,568.5C 396.5,378.833 396.5,189.167 396.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#242a2f",
    d: "M 398.5,-0.5 C 399.5,-0.5 400.5,-0.5 401.5,-0.5C 401.5,329.5 401.5,659.5 401.5,989.5C 400.5,989.5 399.5,989.5 398.5,989.5C 398.5,659.5 398.5,329.5 398.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7dbab4",
    d: "M 42.5,0.5 C 52.1619,2.7403 62.1619,3.90696 72.5,4C 73,4.5 73.5,5 74,5.5C 74.6667,11.8333 74.6667,18.1667 74,24.5C 73.5,25 73,25.5 72.5,26C 62.5,26.6667 52.5,26.6667 42.5,26C 42,25.5 41.5,25 41,24.5C 40.3333,17.1667 40.3333,9.83333 41,2.5C 41.7172,1.9558 42.2172,1.28913 42.5,0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#86929e",
    d: "M 129.5,3.5 C 130.5,3.5 131.5,3.5 132.5,3.5C 132.5,5.16667 132.5,6.83333 132.5,8.5C 140.5,9.16667 140.5,9.83333 132.5,10.5C 132.335,14.1817 132.501,17.8484 133,21.5C 135,22.8333 137,22.8333 139,21.5C 139.483,22.448 139.649,23.448 139.5,24.5C 136.813,24.6641 134.146,24.4974 131.5,24C 130.874,23.2496 130.374,22.4162 130,21.5C 129.501,15.5092 129.334,9.50924 129.5,3.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#86929e",
    d: "M 178.5,3.5 C 179.5,3.5 180.5,3.5 181.5,3.5C 181.5,5.16667 181.5,6.83333 181.5,8.5C 189.5,9.16667 189.5,9.83333 181.5,10.5C 181.335,14.1817 181.501,17.8484 182,21.5C 184,22.8333 186,22.8333 188,21.5C 188.483,22.448 188.649,23.448 188.5,24.5C 185.813,24.6641 183.146,24.4974 180.5,24C 179.874,23.2496 179.374,22.4162 179,21.5C 178.501,15.5092 178.334,9.50924 178.5,3.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1b2225",
    d: "M 44.5,6.5 C 53.1667,6.5 61.8333,6.5 70.5,6.5C 70.5,11.8333 70.5,17.1667 70.5,22.5C 61.8333,22.5 53.1667,22.5 44.5,22.5C 44.5,17.1667 44.5,11.8333 44.5,6.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#838a90",
    d: "M 97.5,7.5 C 105.472,7.63644 108.972,11.6364 108,19.5C 105.565,24.2238 101.731,25.7238 96.5,24C 91.0149,18.0713 91.3483,12.5713 97.5,7.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8f8f8d",
    d: "M 112.5,8.5 C 113.5,8.5 114.5,8.5 115.5,8.5C 115.334,12.5138 115.501,16.5138 116,20.5C 117.754,22.25 119.921,22.9167 122.5,22.5C 122.5,17.8333 122.5,13.1667 122.5,8.5C 123.5,8.5 124.5,8.5 125.5,8.5C 125.5,13.8333 125.5,19.1667 125.5,24.5C 121.563,24.7935 117.73,24.4601 114,23.5C 112.612,18.6278 112.112,13.6278 112.5,8.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#899495",
    d: "M 144.5,7.5 C 156.886,7.94395 159.886,13.4439 153.5,24C 150.854,24.4974 148.187,24.6641 145.5,24.5C 145.5,26.5 145.5,28.5 145.5,30.5C 144.5,30.5 143.5,30.5 142.5,30.5C 141.919,22.5585 142.586,14.8919 144.5,7.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#81909f",
    d: "M 160.5,8.5 C 161.5,8.5 162.5,8.5 163.5,8.5C 163.334,12.5138 163.501,16.5138 164,20.5C 165.789,22.229 167.956,22.8957 170.5,22.5C 170.5,17.8333 170.5,13.1667 170.5,8.5C 171.5,8.5 172.5,8.5 173.5,8.5C 173.5,13.8333 173.5,19.1667 173.5,24.5C 170.15,24.665 166.817,24.4983 163.5,24C 163,23.5 162.5,23 162,22.5C 160.621,17.964 160.121,13.2973 160.5,8.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1f2328",
    d: "M 98.5,10.5 C 100.722,10.178 102.556,10.8446 104,12.5C 105.004,15.9926 104.504,19.1592 102.5,22C 100.299,22.8249 98.4659,22.3249 97,20.5C 96.037,16.8513 96.537,13.518 98.5,10.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#22252b",
    d: "M 145.5,10.5 C 153.036,9.91951 155.536,13.2528 153,20.5C 150.925,22.6483 148.592,22.9817 146,21.5C 145.501,17.8484 145.335,14.1817 145.5,10.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#4bc874",
    d: "M 62.5,53.5 C 71.8333,53.5 81.1667,53.5 90.5,53.5C 90.5,56.1667 90.5,58.8333 90.5,61.5C 81.1667,61.5 71.8333,61.5 62.5,61.5C 62.5,58.8333 62.5,56.1667 62.5,53.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#90908d",
    d: "M 174.5,53.5 C 175.5,53.5 176.5,53.5 177.5,53.5C 176.913,61.3734 177.58,69.04 179.5,76.5C 177.994,77.7472 176.494,77.7472 175,76.5C 174.5,68.8406 174.334,61.1739 174.5,53.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#90908d",
    d: "M 219.5,53.5 C 220.5,53.5 221.5,53.5 222.5,53.5C 221.913,61.3734 222.58,69.04 224.5,76.5C 222.994,77.7472 221.494,77.7472 220,76.5C 219.5,68.8406 219.334,61.1739 219.5,53.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#899497",
    d: "M 182.5,56.5 C 183.5,56.5 184.5,56.5 185.5,56.5C 185.5,58.1667 185.5,59.8333 185.5,61.5C 193.5,62.1667 193.5,62.8333 185.5,63.5C 185.335,67.1817 185.501,70.8484 186,74.5C 187.796,75.767 189.629,75.767 191.5,74.5C 192.386,75.325 192.719,76.325 192.5,77.5C 188.993,78.0065 185.826,77.3398 183,75.5C 182.5,69.1754 182.334,62.8421 182.5,56.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7e8188",
    d: "M 115.5,60.5 C 117.527,60.3379 119.527,60.5045 121.5,61C 121.957,61.414 122.291,61.914 122.5,62.5C 120.604,63.4656 118.604,63.7989 116.5,63.5C 116.5,68.1667 116.5,72.8333 116.5,77.5C 115.167,77.5 113.833,77.5 112.5,77.5C 112.5,72.1667 112.5,66.8333 112.5,61.5C 113.791,61.7373 114.791,61.404 115.5,60.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#868e94",
    d: "M 129.5,60.5 C 136.032,60.6973 139.032,64.0306 138.5,70.5C 134.774,70.1774 131.107,70.5108 127.5,71.5C 128.96,75.4677 131.626,76.4677 135.5,74.5C 136.386,75.325 136.719,76.325 136.5,77.5C 126.247,79.0326 122.414,74.6993 125,64.5C 126.397,62.9297 127.897,61.5964 129.5,60.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8f8f8d",
    d: "M 156.5,61.5 C 157.5,61.5 158.5,61.5 159.5,61.5C 159.334,65.5138 159.501,69.5138 160,73.5C 161.754,75.25 163.921,75.9167 166.5,75.5C 166.5,70.8333 166.5,66.1667 166.5,61.5C 167.5,61.5 168.5,61.5 169.5,61.5C 169.5,66.8333 169.5,72.1667 169.5,77.5C 165.563,77.7935 161.73,77.4601 158,76.5C 156.612,71.6278 156.112,66.6278 156.5,61.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#848f98",
    d: "M 229.5,60.5 C 231.792,60.2436 233.959,60.5769 236,61.5C 236.167,61.8333 236.333,62.1667 236.5,62.5C 227.747,63.8031 227.413,65.9698 235.5,69C 238.07,71.718 238.07,74.3847 235.5,77C 232.518,77.498 229.518,77.6646 226.5,77.5C 226.351,76.448 226.517,75.448 227,74.5C 229.064,75.5914 231.231,75.7581 233.5,75C 234.022,74.4387 234.355,73.772 234.5,73C 231.914,71.348 229.414,69.5147 227,67.5C 226.333,66.1667 226.333,64.8333 227,63.5C 228.045,62.6266 228.878,61.6266 229.5,60.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#546a32",
    d: "M 90.5,79.5 C 90.5,74.5 90.5,69.5 90.5,64.5C 84.8333,64.5 79.1667,64.5 73.5,64.5C 73.5,69.5 73.5,74.5 73.5,79.5C 72.5119,74.3595 72.1786,69.0262 72.5,63.5C 78.8333,63.5 85.1667,63.5 91.5,63.5C 91.8214,69.0262 91.4881,74.3595 90.5,79.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#242528",
    d: "M 129.5,63.5 C 132.95,62.7564 134.616,64.0897 134.5,67.5C 132.167,67.5 129.833,67.5 127.5,67.5C 127.527,65.8007 128.194,64.4674 129.5,63.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#889297",
    d: "M 144.5,60.5 C 146.792,60.2436 148.959,60.5769 151,61.5C 151.167,61.8333 151.333,62.1667 151.5,62.5C 142.315,64.3804 142.315,66.8804 151.5,70C 153.059,72.6417 152.725,74.975 150.5,77C 147.518,77.498 144.518,77.6646 141.5,77.5C 141.351,76.448 141.517,75.448 142,74.5C 144.064,75.5914 146.231,75.7581 148.5,75C 149.022,74.4387 149.355,73.772 149.5,73C 146.914,71.348 144.414,69.5147 142,67.5C 141.833,66.6667 141.667,65.8333 141.5,65C 142.008,63.1074 143.008,61.6074 144.5,60.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#4bc874",
    d: "M 62.5,64.5 C 65.1667,64.5 67.8333,64.5 70.5,64.5C 70.5,69.5 70.5,74.5 70.5,79.5C 67.8333,79.5 65.1667,79.5 62.5,79.5C 62.5,74.5 62.5,69.5 62.5,64.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b2e14b",
    d: "M 90.5,79.5 C 84.8333,79.5 79.1667,79.5 73.5,79.5C 73.5,74.5 73.5,69.5 73.5,64.5C 79.1667,64.5 84.8333,64.5 90.5,64.5C 90.5,69.5 90.5,74.5 90.5,79.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#879096",
    d: "M 240.5,62.5 C 241.708,61.218 243.042,61.218 244.5,62.5C 245.531,63.7003 246.365,65.0337 247,66.5C 248.046,64.9095 249.213,63.4095 250.5,62C 251.5,61.3333 252.5,61.3333 253.5,62C 251.968,64.0344 250.635,66.2011 249.5,68.5C 251.167,71.1667 252.833,73.8333 254.5,76.5C 253.635,77.5827 252.635,77.7494 251.5,77C 248.76,70.3105 246.093,70.1438 243.5,76.5C 242.277,77.6139 240.944,77.7805 239.5,77C 241.561,74.3757 243.227,71.5424 244.5,68.5C 243.535,66.2113 242.202,64.2113 240.5,62.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8b9397",
    d: "M 202.5,61.5 C 203.552,61.3505 204.552,61.5172 205.5,62C 206.304,63.7713 207.471,65.2713 209,66.5C 209.947,63.0016 212.113,61.5016 215.5,62C 213.819,64.344 212.152,66.6773 210.5,69C 212.87,71.51 214.537,74.3433 215.5,77.5C 214.325,77.719 213.325,77.3857 212.5,76.5C 209.833,69.8333 207.167,69.8333 204.5,76.5C 203.5,77.8333 202.5,77.8333 201.5,76.5C 203.049,73.8972 204.715,71.3972 206.5,69C 205.022,66.5413 203.688,64.0413 202.5,61.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#898b8b",
    d: "M 195.5,73.5 C 198.5,73.1667 199.833,74.5 199.5,77.5C 198.167,77.5 196.833,77.5 195.5,77.5C 195.5,76.1667 195.5,74.8333 195.5,73.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#4bc874",
    d: "M 62.5,106.5 C 71.8333,106.5 81.1667,106.5 90.5,106.5C 90.5,109.167 90.5,111.833 90.5,114.5C 81.1667,114.5 71.8333,114.5 62.5,114.5C 62.5,111.833 62.5,109.167 62.5,106.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#808d9d",
    d: "M 192.5,106.5 C 193.5,106.5 194.5,106.5 195.5,106.5C 195.334,113.508 195.5,120.508 196,127.5C 198.683,128.575 198.849,129.575 196.5,130.5C 194.971,130.471 193.804,129.804 193,128.5C 192.5,121.174 192.334,113.841 192.5,106.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#86929e",
    d: "M 112.5,109.5 C 113.5,109.5 114.5,109.5 115.5,109.5C 115.5,111.167 115.5,112.833 115.5,114.5C 123.5,115.167 123.5,115.833 115.5,116.5C 115.335,120.182 115.501,123.848 116,127.5C 118,128.833 120,128.833 122,127.5C 122.483,128.448 122.649,129.448 122.5,130.5C 119.813,130.664 117.146,130.497 114.5,130C 113.874,129.25 113.374,128.416 113,127.5C 112.501,121.509 112.334,115.509 112.5,109.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#919594",
    d: "M 156.5,109.5 C 157.5,109.5 158.5,109.5 159.5,109.5C 159.5,111.167 159.5,112.833 159.5,114.5C 167.5,115.167 167.5,115.833 159.5,116.5C 159.335,120.182 159.501,123.848 160,127.5C 161.667,128.833 163.333,128.833 165,127.5C 165.483,128.448 165.649,129.448 165.5,130.5C 163.143,130.663 160.81,130.497 158.5,130C 157.874,129.25 157.374,128.416 157,127.5C 156.501,121.509 156.334,115.509 156.5,109.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#848f98",
    d: "M 144.5,113.5 C 146.792,113.244 148.959,113.577 151,114.5C 151.167,114.833 151.333,115.167 151.5,115.5C 142.747,116.803 142.413,118.97 150.5,122C 153.07,124.718 153.07,127.385 150.5,130C 147.518,130.498 144.518,130.665 141.5,130.5C 141.351,129.448 141.517,128.448 142,127.5C 144.064,128.591 146.231,128.758 148.5,128C 149.022,127.439 149.355,126.772 149.5,126C 146.914,124.348 144.414,122.515 142,120.5C 141.333,119.167 141.333,117.833 142,116.5C 143.045,115.627 143.878,114.627 144.5,113.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#546a32",
    d: "M 90.5,132.5 C 90.5,127.5 90.5,122.5 90.5,117.5C 84.8333,117.5 79.1667,117.5 73.5,117.5C 73.5,122.5 73.5,127.5 73.5,132.5C 72.5119,127.36 72.1786,122.026 72.5,116.5C 78.8333,116.5 85.1667,116.5 91.5,116.5C 91.8214,122.026 91.4881,127.36 90.5,132.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#889297",
    d: "M 203.5,113.5 C 205.792,113.244 207.959,113.577 210,114.5C 210.167,114.833 210.333,115.167 210.5,115.5C 201.315,117.38 201.315,119.88 210.5,123C 212.059,125.642 211.725,127.975 209.5,130C 206.518,130.498 203.518,130.665 200.5,130.5C 200.351,129.448 200.517,128.448 201,127.5C 203.064,128.591 205.231,128.758 207.5,128C 208.022,127.439 208.355,126.772 208.5,126C 205.914,124.348 203.414,122.515 201,120.5C 200.833,119.667 200.667,118.833 200.5,118C 201.008,116.107 202.008,114.607 203.5,113.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#4bc874",
    d: "M 62.5,117.5 C 65.1667,117.5 67.8333,117.5 70.5,117.5C 70.5,122.5 70.5,127.5 70.5,132.5C 67.8333,132.5 65.1667,132.5 62.5,132.5C 62.5,127.5 62.5,122.5 62.5,117.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b2e14b",
    d: "M 90.5,132.5 C 84.8333,132.5 79.1667,132.5 73.5,132.5C 73.5,127.5 73.5,122.5 73.5,117.5C 79.1667,117.5 84.8333,117.5 90.5,117.5C 90.5,122.5 90.5,127.5 90.5,132.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#868e94",
    d: "M 129.5,113.5 C 136.322,113.324 139.322,116.657 138.5,123.5C 134.833,123.5 131.167,123.5 127.5,123.5C 128.744,128.246 131.744,129.579 136.5,127.5C 137.386,128.325 137.719,129.325 137.5,130.5C 126.749,132.581 122.582,128.248 125,117.5C 126.397,115.93 127.897,114.596 129.5,113.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#24252a",
    d: "M 129.5,116.5 C 132.278,116.022 134.278,117.022 135.5,119.5C 132.833,120.833 130.167,120.833 127.5,119.5C 128.193,118.482 128.859,117.482 129.5,116.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8a9397",
    d: "M 175.5,115.5 C 175.917,114.876 176.584,114.543 177.5,114.5C 179.16,115.787 180.826,117.12 182.5,118.5C 183.845,117.653 184.845,116.487 185.5,115C 186.635,114.251 187.635,114.417 188.5,115.5C 186.556,117.28 185.223,119.447 184.5,122C 186.369,124.368 188.036,126.868 189.5,129.5C 188.635,130.583 187.635,130.749 186.5,130C 184.113,122.958 181.446,122.791 178.5,129.5C 177.5,130.833 176.5,130.833 175.5,129.5C 176.964,126.868 178.631,124.368 180.5,122C 178.984,119.659 177.317,117.492 175.5,115.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#889196",
    d: "M 214.5,115.5 C 215.251,114.427 216.251,114.26 217.5,115C 218.787,116.41 219.954,117.91 221,119.5C 222.172,116.297 224.339,114.797 227.5,115C 225.932,117.058 224.598,119.225 223.5,121.5C 224.773,124.542 226.439,127.376 228.5,130C 227.056,130.781 225.723,130.614 224.5,129.5C 223.876,127.246 222.543,125.579 220.5,124.5C 219.289,126.422 217.956,128.255 216.5,130C 215.365,130.749 214.365,130.583 213.5,129.5C 215.049,126.897 216.715,124.397 218.5,122C 217.715,119.406 216.382,117.239 214.5,115.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#808c96",
    d: "M 169.5,126.5 C 170.5,126.5 171.5,126.5 172.5,126.5C 172.5,127.833 172.5,129.167 172.5,130.5C 171.167,130.5 169.833,130.5 168.5,130.5C 168.433,129.041 168.766,127.708 169.5,126.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7dbab4",
    d: "M 23.5,158.5 C 33.1619,160.74 43.1619,161.907 53.5,162C 54,162.5 54.5,163 55,163.5C 55.6667,169.833 55.6667,176.167 55,182.5C 54.5,183 54,183.5 53.5,184C 43.5,184.667 33.5,184.667 23.5,184C 23,183.5 22.5,183 22,182.5C 21.3333,175.167 21.3333,167.833 22,160.5C 22.7172,159.956 23.2172,159.289 23.5,158.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6eab7f",
    d: "M 84.5,159.5 C 85.8333,159.5 87.1667,159.5 88.5,159.5C 88.5,167.5 88.5,175.5 88.5,183.5C 84.8183,183.665 81.1516,183.499 77.5,183C 73.2119,179.229 72.3786,174.729 75,169.5C 77.5715,166.653 80.5715,165.987 84,167.5C 84.4974,164.854 84.6641,162.187 84.5,159.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#77b881",
    d: "M 110.5,159.5 C 111.5,159.5 112.5,159.5 113.5,159.5C 113.336,162.187 113.503,164.854 114,167.5C 122.834,166.396 126.168,170.396 124,179.5C 123.167,180.5 122.333,181.5 121.5,182.5C 117.906,183.426 114.24,183.759 110.5,183.5C 110.5,175.5 110.5,167.5 110.5,159.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#40604e",
    d: "M 344.5,162.5 C 354.247,163.328 357.414,168.328 354,177.5C 349,182.833 344,182.833 339,177.5C 335.816,170.551 337.65,165.551 344.5,162.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1b2225",
    d: "M 25.5,164.5 C 34.1667,164.5 42.8333,164.5 51.5,164.5C 51.5,169.833 51.5,175.167 51.5,180.5C 42.8333,180.5 34.1667,180.5 25.5,180.5C 25.5,175.167 25.5,169.833 25.5,164.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#72b382",
    d: "M 97.5,166.5 C 103.983,166.651 106.983,169.984 106.5,176.5C 102.774,176.177 99.1073,176.511 95.5,177.5C 97.3253,181.543 100.325,182.543 104.5,180.5C 105.386,181.325 105.719,182.325 105.5,183.5C 94.7269,185.56 90.5602,181.227 93,170.5C 94.3968,168.93 95.8968,167.596 97.5,166.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#73bd8a",
    d: "M 128.5,167.5 C 129.5,167.5 130.5,167.5 131.5,167.5C 131.335,171.182 131.501,174.848 132,178.5C 133.287,181.145 135.453,182.145 138.5,181.5C 138.5,176.833 138.5,172.167 138.5,167.5C 139.5,167.5 140.5,167.5 141.5,167.5C 141.5,172.833 141.5,178.167 141.5,183.5C 138.15,183.665 134.817,183.498 131.5,183C 131,182.5 130.5,182 130,181.5C 128.621,176.964 128.121,172.297 128.5,167.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#70b386",
    d: "M 151.5,166.5 C 153.92,166.292 156.253,166.626 158.5,167.5C 159.664,173.807 159.831,180.141 159,186.5C 155.662,189.318 151.829,190.151 147.5,189C 147.043,188.586 146.709,188.086 146.5,187.5C 149.447,186.679 152.447,186.179 155.5,186C 156.337,184.989 156.67,183.822 156.5,182.5C 148.395,183.228 144.895,179.562 146,171.5C 147.73,169.598 149.563,167.931 151.5,166.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#202625",
    d: "M 79.5,169.5 C 81.1439,169.286 82.6439,169.62 84,170.5C 84.4986,174.152 84.6653,177.818 84.5,181.5C 78.2598,181.706 75.7598,178.706 77,172.5C 77.6979,171.309 78.5313,170.309 79.5,169.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#20282b",
    d: "M 97.5,169.5 C 100.278,169.022 102.278,170.022 103.5,172.5C 100.833,173.833 98.1667,173.833 95.5,172.5C 96.1925,171.482 96.8592,170.482 97.5,169.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1d262a",
    d: "M 114.5,169.5 C 121.03,169.243 123.197,172.243 121,178.5C 119.152,181.041 116.652,182.041 113.5,181.5C 113.237,177.4 113.57,173.4 114.5,169.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1d2325",
    d: "M 151.5,169.5 C 153.167,169.5 154.833,169.5 156.5,169.5C 156.665,172.85 156.498,176.183 156,179.5C 153.733,180.935 151.733,180.602 150,178.5C 149.068,175.177 149.568,172.177 151.5,169.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#798f9a",
    d: "M 44.5,210.5 C 53.1667,210.5 61.8333,210.5 70.5,210.5C 70.5,216.833 70.5,223.167 70.5,229.5C 67.1667,229.5 63.8333,229.5 60.5,229.5C 60.5,232.5 60.5,235.5 60.5,238.5C 55.1667,238.5 49.8333,238.5 44.5,238.5C 44.5,229.167 44.5,219.833 44.5,210.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#75b380",
    d: "M 104.5,212.5 C 105.5,212.5 106.5,212.5 107.5,212.5C 107.5,220.5 107.5,228.5 107.5,236.5C 96.9079,239.059 92.0746,235.059 93,224.5C 94.5,223 96,221.5 97.5,220C 99.5675,219.313 101.568,219.48 103.5,220.5C 104.48,217.914 104.813,215.247 104.5,212.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#75bd87",
    d: "M 129.5,212.5 C 130.5,212.5 131.5,212.5 132.5,212.5C 132.187,215.247 132.52,217.914 133.5,220.5C 137.373,219.009 140.539,220.009 143,223.5C 145.287,234.633 140.787,238.967 129.5,236.5C 129.5,228.5 129.5,220.5 129.5,212.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#73b684",
    d: "M 236.5,214.5 C 244.16,212.996 247.327,215.996 246,223.5C 243.688,226.646 241.188,229.646 238.5,232.5C 241.428,233.484 244.428,233.817 247.5,233.5C 247.5,234.5 247.5,235.5 247.5,236.5C 243.167,236.5 238.833,236.5 234.5,236.5C 234.725,231.756 236.892,228.09 241,225.5C 243.346,223.294 243.846,220.794 242.5,218C 239.764,217.578 237.098,217.578 234.5,218C 234.167,217.667 233.833,217.333 233.5,217C 234.571,216.148 235.571,215.315 236.5,214.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#5f9471",
    d: "M 339.5,216.5 C 341.167,216.5 342.833,216.5 344.5,216.5C 344.334,221.179 344.501,225.845 345,230.5C 347.267,231.935 349.267,231.602 351,229.5C 351.499,225.179 351.666,220.846 351.5,216.5C 352.833,216.5 354.167,216.5 355.5,216.5C 355.666,221.511 355.499,226.511 355,231.5C 353.471,234.516 350.971,235.849 347.5,235.5C 343.823,235.664 341.323,233.997 340,230.5C 339.501,225.845 339.334,221.179 339.5,216.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#73ba89",
    d: "M 253.5,214.5 C 262.768,213.076 265.435,216.409 261.5,224.5C 265.468,228.417 265.468,232.251 261.5,236C 258.183,236.498 254.85,236.665 251.5,236.5C 251.281,235.325 251.614,234.325 252.5,233.5C 255.614,235.062 258.447,234.729 261,232.5C 261.833,228.164 260,226.164 255.5,226.5C 255.5,225.5 255.5,224.5 255.5,223.5C 260.159,223.985 261.492,222.152 259.5,218C 257.231,217.242 255.064,217.409 253,218.5C 252.421,217.072 252.588,215.738 253.5,214.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#76b984",
    d: "M 282.5,214.5 C 287.133,213.458 290.299,215.125 292,219.5C 292.667,223.5 292.667,227.5 292,231.5C 289.975,236.145 286.475,237.645 281.5,236C 280.107,234.829 279.273,233.329 279,231.5C 278.333,227.167 278.333,222.833 279,218.5C 280.376,217.295 281.542,215.962 282.5,214.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1e252a",
    d: "M 283.5,217.5 C 286.238,216.965 288.072,217.965 289,220.5C 289.667,224.167 289.667,227.833 289,231.5C 285.943,235.65 283.61,235.316 282,230.5C 280.978,225.871 281.478,221.538 283.5,217.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#73b382",
    d: "M 152.5,233.5 C 154.265,234.461 156.265,234.795 158.5,234.5C 158.5,229.833 158.5,225.167 158.5,220.5C 159.5,220.5 160.5,220.5 161.5,220.5C 161.5,225.833 161.5,231.167 161.5,236.5C 157.818,236.665 154.152,236.499 150.5,236C 150,235.5 149.5,235 149,234.5C 147.621,229.964 147.121,225.297 147.5,220.5C 148.5,220.5 149.5,220.5 150.5,220.5C 150.335,224.182 150.501,227.848 151,231.5C 151.278,232.416 151.778,233.082 152.5,233.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#347475",
    d: "M 158.5,220.5 C 158.5,225.167 158.5,229.833 158.5,234.5C 156.265,234.795 154.265,234.461 152.5,233.5C 154.167,233.5 155.833,233.5 157.5,233.5C 157.182,228.968 157.515,224.634 158.5,220.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#70b386",
    d: "M 170.5,219.5 C 172.92,219.292 175.253,219.626 177.5,220.5C 178.664,226.807 178.831,233.141 178,239.5C 174.662,242.318 170.829,243.151 166.5,242C 166.043,241.586 165.709,241.086 165.5,240.5C 168.447,239.679 171.447,239.179 174.5,239C 175.337,237.989 175.67,236.822 175.5,235.5C 167.395,236.228 163.895,232.562 165,224.5C 166.73,222.598 168.563,220.931 170.5,219.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1c2223",
    d: "M 103.5,223.5 C 103.5,226.833 103.5,230.167 103.5,233.5C 101.833,233.5 100.167,233.5 98.5,233.5C 97.8826,233.389 97.3826,233.056 97,232.5C 96.3333,229.833 96.3333,227.167 97,224.5C 98.8976,222.316 101.064,221.983 103.5,223.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1f2629",
    d: "M 133.5,222.5 C 138.085,221.592 140.418,223.425 140.5,228C 140.408,233.223 137.741,235.39 132.5,234.5C 132.237,230.4 132.57,226.4 133.5,222.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1d2325",
    d: "M 170.5,222.5 C 172.167,222.5 173.833,222.5 175.5,222.5C 175.665,225.85 175.498,229.183 175,232.5C 172.733,233.935 170.733,233.602 169,231.5C 168.068,228.177 168.568,225.177 170.5,222.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#275662",
    d: "M 103.5,223.5 C 104.482,226.962 104.815,230.629 104.5,234.5C 102.265,234.795 100.265,234.461 98.5,233.5C 100.167,233.5 101.833,233.5 103.5,233.5C 103.5,230.167 103.5,226.833 103.5,223.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#72b583",
    d: "M 116.5,219.5 C 122.983,219.651 125.983,222.984 125.5,229.5C 121.818,229.335 118.152,229.501 114.5,230C 116.476,234.359 119.643,235.526 124,233.5C 124.483,234.448 124.649,235.448 124.5,236.5C 114.211,238.633 110.045,234.633 112,224.5C 113.025,222.313 114.525,220.646 116.5,219.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#222729",
    d: "M 116.5,222.5 C 119.278,222.022 121.278,223.022 122.5,225.5C 119.833,226.833 117.167,226.833 114.5,225.5C 115.193,224.482 115.859,223.482 116.5,222.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#73b888",
    d: "M 267.5,225.5 C 270.167,225.5 272.833,225.5 275.5,225.5C 275.5,226.5 275.5,227.5 275.5,228.5C 272.833,228.5 270.167,228.5 267.5,228.5C 267.5,227.5 267.5,226.5 267.5,225.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#70b283",
    d: "M 201.5,214.5 C 209.738,213.558 212.572,216.891 210,224.5C 207.128,227.037 204.628,229.87 202.5,233C 205.817,233.498 209.15,233.665 212.5,233.5C 212.5,234.5 212.5,235.5 212.5,236.5C 207.833,236.5 203.167,236.5 198.5,236.5C 198.491,234.692 198.991,233.025 200,231.5C 203.057,227.951 205.891,224.284 208.5,220.5C 208.392,219.558 208.059,218.725 207.5,218C 204.764,217.578 202.098,217.578 199.5,218C 199.167,217.667 198.833,217.333 198.5,217C 199.571,216.148 200.571,215.315 201.5,214.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7bc0df",
    d: "M 63.5,231.5 C 65.5273,231.338 67.5273,231.505 69.5,232C 67.6667,233.833 65.8333,235.667 64,237.5C 63.5045,235.527 63.3379,233.527 63.5,231.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#74b482",
    d: "M 220.5,214.5 C 225.624,213.464 228.79,215.464 230,220.5C 231.289,226.322 230.122,231.489 226.5,236C 220.453,237.954 216.953,235.787 216,229.5C 214.625,223.471 216.125,218.471 220.5,214.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1e272b",
    d: "M 220.5,217.5 C 223.547,216.855 225.713,217.855 227,220.5C 227.767,224.594 227.434,228.594 226,232.5C 223.478,235.326 221.478,234.993 220,231.5C 219.283,226.78 219.45,222.114 220.5,217.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#73b17d",
    d: "M 297.5,232.5 C 300.5,232.167 301.833,233.5 301.5,236.5C 300.167,236.5 298.833,236.5 297.5,236.5C 297.5,235.167 297.5,233.833 297.5,232.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#72ba87",
    d: "M 308.5,232.5 C 310.912,232.694 311.912,234.027 311.5,236.5C 310.167,236.5 308.833,236.5 307.5,236.5C 307.433,235.041 307.766,233.708 308.5,232.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6ba479",
    d: "M 318.5,232.5 C 321.5,232.167 322.833,233.5 322.5,236.5C 320.833,236.5 319.167,236.5 317.5,236.5C 317.433,235.041 317.766,233.708 318.5,232.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#70b284",
    d: "M 181.5,239.5 C 186.5,239.5 191.5,239.5 196.5,239.5C 196.5,240.5 196.5,241.5 196.5,242.5C 191.5,242.5 186.5,242.5 181.5,242.5C 181.5,241.5 181.5,240.5 181.5,239.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#41515b",
    d: "M 23.5,264.5 C 33.1619,266.74 43.1619,267.907 53.5,268C 54,268.5 54.5,269 55,269.5C 55.6667,275.833 55.6667,282.167 55,288.5C 54.5,289 54,289.5 53.5,290C 43.5,290.667 33.5,290.667 23.5,290C 23,289.5 22.5,289 22,288.5C 21.3333,281.167 21.3333,273.833 22,266.5C 22.7172,265.956 23.2172,265.289 23.5,264.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#857e77",
    d: "M 91.5,264.5 C 92.5,264.5 93.5,264.5 94.5,264.5C 94.3359,267.187 94.5026,269.854 95,272.5C 103.361,271.202 106.695,274.869 105,283.5C 104.215,285.286 103.049,286.786 101.5,288C 98.1832,288.498 94.8499,288.665 91.5,288.5C 91.5,280.5 91.5,272.5 91.5,264.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#85867e",
    d: "M 74.5,264.5 C 75.5,264.5 76.5,264.5 77.5,264.5C 77.3337,271.508 77.5004,278.508 78,285.5C 79.7844,286.667 79.7844,287.667 78,288.5C 76.7387,288.241 75.7387,287.574 75,286.5C 74.5003,279.174 74.3337,271.841 74.5,264.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7e7e7a",
    d: "M 83.5,265.5 C 86.8606,266.203 87.1939,267.537 84.5,269.5C 82.3576,268.563 82.0243,267.23 83.5,265.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#867b72",
    d: "M 83.5,272.5 C 84.5,272.5 85.5,272.5 86.5,272.5C 86.5,277.833 86.5,283.167 86.5,288.5C 85.5,288.5 84.5,288.5 83.5,288.5C 83.5,283.167 83.5,277.833 83.5,272.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1e262c",
    d: "M 94.5,274.5 C 99.4352,273.623 102.102,275.623 102.5,280.5C 101.863,285.131 99.1961,287.131 94.5,286.5C 94.5,282.5 94.5,278.5 94.5,274.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7fbcb7",
    d: "M 23.5,316.5 C 27.5138,316.334 31.5138,316.501 35.5,317C 36.1667,317.667 36.8333,318.333 37.5,319C 42.8333,319.333 48.1667,319.667 53.5,320C 56.4989,324.059 55.8322,325.059 51.5,323C 42.8397,322.5 34.1731,322.334 25.5,322.5C 25.5,327.833 25.5,333.167 25.5,338.5C 27.5,338.5 29.5,338.5 31.5,338.5C 31.5,339.833 31.5,341.167 31.5,342.5C 27.9929,343.006 24.8263,342.34 22,340.5C 21.3333,333.167 21.3333,325.833 22,318.5C 22.7172,317.956 23.2172,317.289 23.5,316.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#665d4d",
    d: "M 344.5,320.5 C 354.247,321.328 357.414,326.328 354,335.5C 349,340.833 344,340.833 339,335.5C 335.829,328.529 337.662,323.529 344.5,320.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#cab280",
    d: "M 90.5,324.5 C 92.8333,324.5 95.1667,324.5 97.5,324.5C 97.5,325.5 97.5,326.5 97.5,327.5C 95.5,327.5 93.5,327.5 91.5,327.5C 91.5,332.167 91.5,336.833 91.5,341.5C 90.5,341.5 89.5,341.5 88.5,341.5C 87.9546,335.537 88.6213,329.87 90.5,324.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3b65b8",
    d: "M 34.5,326.5 C 41.1667,326.5 47.8333,326.5 54.5,326.5C 54.6662,332.842 54.4995,339.175 54,345.5C 47.5898,346.478 41.0898,346.811 34.5,346.5C 34.5,339.833 34.5,333.167 34.5,326.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ceb283",
    d: "M 76.5,324.5 C 78.7925,324.244 80.9592,324.577 83,325.5C 83.1667,325.833 83.3333,326.167 83.5,326.5C 74.7467,327.803 74.4133,329.97 82.5,333C 85.0701,335.718 85.0701,338.385 82.5,341C 79.5184,341.498 76.5184,341.665 73.5,341.5C 73.281,340.325 73.6143,339.325 74.5,338.5C 77.483,340.206 79.8164,339.706 81.5,337C 79.1194,335.054 76.6194,333.221 74,331.5C 73.3333,330.167 73.3333,328.833 74,327.5C 75.045,326.627 75.8783,325.627 76.5,324.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c8a87a",
    d: "M 105.5,324.5 C 107.199,324.34 108.866,324.506 110.5,325C 112.141,328.435 111.307,329.268 108,327.5C 106.289,327.439 104.956,328.106 104,329.5C 101.525,337.175 104.025,340.175 111.5,338.5C 112.386,339.325 112.719,340.325 112.5,341.5C 102.895,343.061 98.7287,339.061 100,329.5C 101.73,327.598 103.563,325.931 105.5,324.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1f2835",
    d: "M 40.5,331.5 C 44.0894,332.372 44.4227,334.039 41.5,336.5C 43.9572,338.332 43.9572,339.999 41.5,341.5C 39.5,340.167 37.8333,338.5 36.5,336.5C 37.8569,334.814 39.1902,333.148 40.5,331.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1f2835",
    d: "M 46.5,331.5 C 53.8661,334.212 54.1994,337.545 47.5,341.5C 45.0428,339.999 45.0428,338.332 47.5,336.5C 45.5764,335.035 45.2431,333.368 46.5,331.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#575857",
    d: "M 30.5,568.5 C 30.5,586.167 30.5,603.833 30.5,621.5C 29.8333,621.5 29.1667,621.5 28.5,621.5C 28.5,603.833 28.5,586.167 28.5,568.5C 29.1667,287.167 29.8333,287.167 30.5,568.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#41515b",
    d: "M 42.5,369.5 C 52.1619,371.74 62.1619,372.907 72.5,373C 73,373.5 73.5,374 74,374.5C 74.6667,380.833 74.6667,387.167 74,393.5C 73.5,394 73,394.5 72.5,395C 62.5,395.667 52.5,395.667 42.5,395C 42,394.5 41.5,394 41,393.5C 40.3333,386.167 40.3333,378.833 41,371.5C 41.7172,370.956 42.2172,370.289 42.5,369.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d5b07b",
    d: "M 203.5,370.5 C 204.5,370.5 205.5,370.5 206.5,370.5C 206.336,373.187 206.503,375.854 207,378.5C 210.429,376.987 213.429,377.653 216,380.5C 216.499,385.155 216.666,389.821 216.5,394.5C 215.5,394.5 214.5,394.5 213.5,394.5C 213.826,390.116 213.492,385.783 212.5,381.5C 210.591,380.652 208.591,380.318 206.5,380.5C 206.5,385.167 206.5,389.833 206.5,394.5C 205.5,394.5 204.5,394.5 203.5,394.5C 203.5,386.5 203.5,378.5 203.5,370.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#665d4d",
    d: "M 344.5,373.5 C 354.247,374.328 357.414,379.328 354,388.5C 349,393.833 344,393.833 339,388.5C 335.829,381.529 337.662,376.529 344.5,373.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ccb07f",
    d: "M 126.5,377.5 C 136.878,377.031 140.712,381.698 138,391.5C 135.103,394.231 131.603,395.231 127.5,394.5C 127.5,396.5 127.5,398.5 127.5,400.5C 126.5,400.5 125.5,400.5 124.5,400.5C 123.919,392.559 124.586,384.892 126.5,377.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ccab7d",
    d: "M 174.5,377.5 C 178.192,376.971 181.358,377.971 184,380.5C 184.499,385.155 184.666,389.821 184.5,394.5C 180.818,394.665 177.152,394.499 173.5,394C 170.367,387.263 172.701,384.096 180.5,384.5C 180.67,383.178 180.337,382.011 179.5,381C 177.423,380.808 175.423,380.308 173.5,379.5C 173.863,378.817 174.196,378.15 174.5,377.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#cead7d",
    d: "M 193.5,377.5 C 195.199,377.34 196.866,377.506 198.5,378C 200.141,381.435 199.307,382.268 196,380.5C 194.289,380.439 192.956,381.106 192,382.5C 191.107,385.916 191.607,389.083 193.5,392C 195.769,392.758 197.936,392.591 200,391.5C 200.483,392.448 200.649,393.448 200.5,394.5C 190.247,396.033 186.414,391.699 189,381.5C 190.397,379.93 191.897,378.596 193.5,377.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#cbac7e",
    d: "M 225.5,377.5 C 231.983,377.651 234.983,380.984 234.5,387.5C 230.774,387.177 227.107,387.511 223.5,388.5C 225.53,392.374 228.53,393.374 232.5,391.5C 233.386,392.325 233.719,393.325 233.5,394.5C 222.727,396.56 218.56,392.227 221,381.5C 222.397,379.93 223.897,378.596 225.5,377.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#27282b",
    d: "M 225.5,380.5 C 228.278,380.022 230.278,381.022 231.5,383.5C 228.833,384.833 226.167,384.833 223.5,383.5C 224.193,382.482 224.859,381.482 225.5,380.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#28272a",
    d: "M 127.5,380.5 C 135.036,379.92 137.536,383.253 135,390.5C 132.925,392.648 130.592,392.982 128,391.5C 127.501,387.848 127.335,384.182 127.5,380.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#29292b",
    d: "M 175.5,387.5 C 177.5,387.5 179.5,387.5 181.5,387.5C 181.5,389.167 181.5,390.833 181.5,392.5C 179.473,392.662 177.473,392.495 175.5,392C 174.272,390.51 174.272,389.01 175.5,387.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#cbab7b",
    d: "M 141.5,378.5 C 142.5,378.5 143.5,378.5 144.5,378.5C 146.896,393.101 149.229,393.101 151.5,378.5C 152.5,378.5 153.5,378.5 154.5,378.5C 153.655,385.87 151.321,392.704 147.5,399C 145.323,400.202 142.989,400.702 140.5,400.5C 140.5,399.5 140.5,398.5 140.5,397.5C 142.199,397.66 143.866,397.494 145.5,397C 146.059,396.275 146.392,395.442 146.5,394.5C 144.247,389.334 142.581,384 141.5,378.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d2b07f",
    d: "M 162.5,377.5 C 164.5,377.5 166.5,377.5 168.5,377.5C 168.5,378.5 168.5,379.5 168.5,380.5C 161.497,379.673 158.997,382.673 161,389.5C 163.128,392.458 165.794,393.124 169,391.5C 169.483,392.448 169.649,393.448 169.5,394.5C 159.219,395.955 155.386,391.622 158,381.5C 159.397,379.93 160.897,378.596 162.5,377.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#bfa37b",
    d: "M 91.5,397.5 C 101.833,397.5 112.167,397.5 122.5,397.5C 122.5,398.5 122.5,399.5 122.5,400.5C 112.167,400.5 101.833,400.5 91.5,400.5C 91.5,399.5 91.5,398.5 91.5,397.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#bca17a",
    d: "M 235.5,397.5 C 246.167,397.5 256.833,397.5 267.5,397.5C 267.5,398.5 267.5,399.5 267.5,400.5C 256.833,400.5 246.167,400.5 235.5,400.5C 235.5,399.5 235.5,398.5 235.5,397.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8ad1f0",
    d: "M 63.5,431.5 C 63.822,433.722 63.1554,435.556 61.5,437C 58.3054,437.181 55.3054,437.681 52.5,438.5C 50.7868,439.635 50.1201,441.302 50.5,443.5C 49.5,443.5 48.5,443.5 47.5,443.5C 43.2193,433.611 46.5527,429.444 57.5,431C 55.5273,430.505 53.5273,430.338 51.5,430.5C 51.0807,426.42 52.914,424.42 57,424.5C 62.1388,424.142 64.3055,426.475 63.5,431.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#838889",
    d: "M 128.5,424.5 C 130.346,424.222 131.68,424.889 132.5,426.5C 131.68,428.111 130.346,428.778 128.5,428.5C 128.5,427.167 128.5,425.833 128.5,424.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#2e4048",
    d: "M 53.5,426.5 C 55.337,426.639 55.6704,427.306 54.5,428.5C 53.7025,428.043 53.3691,427.376 53.5,426.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#eec16d",
    d: "M 64.5,431.5 C 68.3047,431.643 69.9714,433.643 69.5,437.5C 69.9711,442.025 67.9711,444.359 63.5,444.5C 63.8588,446.766 63.1922,448.599 61.5,450C 58.8333,450.667 56.1667,450.667 53.5,450C 52.944,449.617 52.6107,449.117 52.5,448.5C 52.5,445.167 52.5,441.833 52.5,438.5C 55.8499,438.665 59.1832,438.498 62.5,438C 64.229,436.211 64.8957,434.044 64.5,431.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#878e92",
    d: "M 95.5,430.5 C 99.1916,429.971 102.358,430.971 105,433.5C 105.499,438.155 105.666,442.821 105.5,447.5C 101.818,447.665 98.1516,447.499 94.5,447C 91.613,443.655 91.9464,440.655 95.5,438C 97.8098,437.503 100.143,437.337 102.5,437.5C 102.719,436.325 102.386,435.325 101.5,434.5C 99.1463,433.94 96.813,433.273 94.5,432.5C 94.8627,431.817 95.1961,431.15 95.5,430.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#82888e",
    d: "M 111.5,430.5 C 121.646,429.293 125.813,433.627 124,443.5C 121.056,447.114 117.223,448.447 112.5,447.5C 112.5,449.5 112.5,451.5 112.5,453.5C 111.5,453.5 110.5,453.5 109.5,453.5C 108.919,445.559 109.586,437.892 111.5,430.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8c9897",
    d: "M 128.5,431.5 C 129.5,431.5 130.5,431.5 131.5,431.5C 131.5,436.833 131.5,442.167 131.5,447.5C 130.5,447.5 129.5,447.5 128.5,447.5C 128.5,442.167 128.5,436.833 128.5,431.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#82888e",
    d: "M 145.5,430.5 C 155.646,429.293 159.813,433.627 158,443.5C 155.056,447.114 151.223,448.447 146.5,447.5C 146.5,449.5 146.5,451.5 146.5,453.5C 145.5,453.5 144.5,453.5 143.5,453.5C 142.919,445.559 143.586,437.892 145.5,430.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1e252c",
    d: "M 113.5,433.5 C 121.957,434.437 123.624,438.27 118.5,445C 116.888,445.72 115.388,445.554 114,444.5C 113.501,440.848 113.335,437.182 113.5,433.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1e252c",
    d: "M 147.5,433.5 C 155.957,434.437 157.624,438.27 152.5,445C 150.888,445.72 149.388,445.554 148,444.5C 147.501,440.848 147.335,437.182 147.5,433.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#716345",
    d: "M 63.5,431.5 C 63.8333,431.5 64.1667,431.5 64.5,431.5C 64.8957,434.044 64.229,436.211 62.5,438C 59.1832,438.498 55.8499,438.665 52.5,438.5C 55.3054,437.681 58.3054,437.181 61.5,437C 63.1554,435.556 63.822,433.722 63.5,431.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#25262b",
    d: "M 96.5,440.5 C 98.5,440.5 100.5,440.5 102.5,440.5C 102.5,442.167 102.5,443.833 102.5,445.5C 100.473,445.662 98.4727,445.495 96.5,445C 95.2721,443.51 95.2721,442.01 96.5,440.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#66716e",
    d: "M 52.5,438.5 C 52.5,441.833 52.5,445.167 52.5,448.5C 51.5655,447.432 51.2322,446.099 51.5,444.5C 49.901,444.768 48.5676,444.434 47.5,443.5C 48.5,443.5 49.5,443.5 50.5,443.5C 50.1201,441.302 50.7868,439.635 52.5,438.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#858a8c",
    d: "M 160.5,431.5 C 161.822,431.33 162.989,431.663 164,432.5C 167.398,447.119 169.564,446.785 170.5,431.5C 171.833,431.5 173.167,431.5 174.5,431.5C 173.081,438.591 170.581,445.258 167,451.5C 164.772,453.113 162.272,453.78 159.5,453.5C 159.5,452.5 159.5,451.5 159.5,450.5C 162.596,451.093 164.929,450.093 166.5,447.5C 163.895,442.427 161.895,437.094 160.5,431.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#879398",
    d: "M 136.5,443.5 C 138.912,443.694 139.912,445.027 139.5,447.5C 138.167,447.5 136.833,447.5 135.5,447.5C 135.433,446.041 135.766,444.708 136.5,443.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8ad1f0",
    d: "M 63.5,483.5 C 63.822,485.722 63.1554,487.556 61.5,489C 58.3054,489.181 55.3054,489.681 52.5,490.5C 50.7868,491.635 50.1201,493.302 50.5,495.5C 49.5,495.5 48.5,495.5 47.5,495.5C 43.2193,485.611 46.5527,481.444 57.5,483C 55.5273,482.505 53.5273,482.338 51.5,482.5C 51.0807,478.42 52.914,476.42 57,476.5C 62.1388,476.142 64.3055,478.475 63.5,483.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#86969d",
    d: "M 93.5,476.5 C 94.5,476.5 95.5,476.5 96.5,476.5C 96.3337,483.508 96.5004,490.508 97,497.5C 98.7844,498.667 98.7844,499.667 97,500.5C 95.7387,500.241 94.7387,499.574 94,498.5C 93.5003,491.174 93.3337,483.841 93.5,476.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#2e4048",
    d: "M 53.5,478.5 C 55.337,478.639 55.6704,479.306 54.5,480.5C 53.7025,480.043 53.3691,479.376 53.5,478.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#eec16d",
    d: "M 64.5,483.5 C 68.3047,483.643 69.9714,485.643 69.5,489.5C 69.9711,494.025 67.9711,496.359 63.5,496.5C 63.8588,498.766 63.1922,500.599 61.5,502C 58.8333,502.667 56.1667,502.667 53.5,502C 52.944,501.617 52.6107,501.117 52.5,500.5C 52.5,497.167 52.5,493.833 52.5,490.5C 55.8499,490.665 59.1832,490.498 62.5,490C 64.229,488.211 64.8957,486.044 64.5,483.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#899397",
    d: "M 106.5,483.5 C 115.192,483.701 118.359,488.035 116,496.5C 110.833,502.092 106.167,501.759 102,495.5C 100.309,490.131 101.809,486.131 106.5,483.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#828c96",
    d: "M 125.5,483.5 C 127.92,483.292 130.253,483.626 132.5,484.5C 133.664,490.472 133.83,496.472 133,502.5C 132.5,504.333 131.333,505.5 129.5,506C 126.833,506.667 124.167,506.667 121.5,506C 121.043,505.586 120.709,505.086 120.5,504.5C 123.447,503.679 126.447,503.179 129.5,503C 130.337,501.989 130.67,500.822 130.5,499.5C 122.345,500.18 118.845,496.514 120,488.5C 121.73,486.598 123.563,484.931 125.5,483.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#899495",
    d: "M 148.5,483.5 C 160.886,483.944 163.886,489.444 157.5,500C 154.854,500.497 152.187,500.664 149.5,500.5C 149.5,502.5 149.5,504.5 149.5,506.5C 148.5,506.5 147.5,506.5 146.5,506.5C 145.919,498.559 146.586,490.892 148.5,483.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#24262b",
    d: "M 106.5,486.5 C 113.03,486.243 115.197,489.243 113,495.5C 110.633,498.932 107.966,499.265 105,496.5C 104.037,492.851 104.537,489.518 106.5,486.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1e2225",
    d: "M 125.5,486.5 C 127.167,486.5 128.833,486.5 130.5,486.5C 130.665,489.85 130.498,493.183 130,496.5C 127.733,497.935 125.733,497.602 124,495.5C 123.068,492.177 123.568,489.177 125.5,486.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#22252b",
    d: "M 149.5,486.5 C 157.036,485.92 159.536,489.253 157,496.5C 154.925,498.648 152.592,498.982 150,497.5C 149.501,493.848 149.335,490.182 149.5,486.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#716345",
    d: "M 63.5,483.5 C 63.8333,483.5 64.1667,483.5 64.5,483.5C 64.8957,486.044 64.229,488.211 62.5,490C 59.1832,490.498 55.8499,490.665 52.5,490.5C 55.3054,489.681 58.3054,489.181 61.5,489C 63.1554,487.556 63.822,485.722 63.5,483.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#66716e",
    d: "M 52.5,490.5 C 52.5,493.833 52.5,497.167 52.5,500.5C 51.5655,499.432 51.2322,498.099 51.5,496.5C 49.901,496.768 48.5676,496.434 47.5,495.5C 48.5,495.5 49.5,495.5 50.5,495.5C 50.1201,493.302 50.7868,491.635 52.5,490.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#888c8c",
    d: "M 162.5,485.5 C 163.568,484.566 164.901,484.232 166.5,484.5C 166.953,488.693 168.119,492.693 170,496.5C 171.275,492.511 172.442,488.511 173.5,484.5C 174.5,484.5 175.5,484.5 176.5,484.5C 175.363,490.741 173.53,496.741 171,502.5C 168.592,505.62 165.426,506.953 161.5,506.5C 161.5,505.5 161.5,504.5 161.5,503.5C 163.527,503.662 165.527,503.495 167.5,503C 168.059,502.275 168.392,501.442 168.5,500.5C 165.733,495.722 163.733,490.722 162.5,485.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#898b8b",
    d: "M 138.5,496.5 C 141.5,496.167 142.833,497.5 142.5,500.5C 141.167,500.5 139.833,500.5 138.5,500.5C 138.5,499.167 138.5,497.833 138.5,496.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#808f9d",
    d: "M 149.5,528.5 C 150.5,528.5 151.5,528.5 152.5,528.5C 152.5,536.5 152.5,544.5 152.5,552.5C 141.845,554.343 137.345,550.01 139,539.5C 141.627,535.847 144.96,534.847 149,536.5C 149.497,533.854 149.664,531.187 149.5,528.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8ad1f0",
    d: "M 63.5,537.5 C 63.822,539.722 63.1554,541.556 61.5,543C 58.3054,543.181 55.3054,543.681 52.5,544.5C 50.7868,545.635 50.1201,547.302 50.5,549.5C 49.5,549.5 48.5,549.5 47.5,549.5C 43.2193,539.611 46.5527,535.444 57.5,537C 55.5273,536.505 53.5273,536.338 51.5,536.5C 51.0807,532.42 52.914,530.42 57,530.5C 62.1388,530.142 64.3055,532.475 63.5,537.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#2e4048",
    d: "M 53.5,532.5 C 55.337,532.639 55.6704,533.306 54.5,534.5C 53.7025,534.043 53.3691,533.376 53.5,532.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#87959f",
    d: "M 93.5,536.5 C 96.5719,536.183 99.5719,536.516 102.5,537.5C 100.604,538.466 98.604,538.799 96.5,538.5C 96.5,543.167 96.5,547.833 96.5,552.5C 95.5,552.5 94.5,552.5 93.5,552.5C 93.5,547.167 93.5,541.833 93.5,536.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#858f96",
    d: "M 124.5,535.5 C 127.807,535.063 130.807,535.73 133.5,537.5C 134.494,542.456 134.827,547.456 134.5,552.5C 131.15,552.665 127.817,552.498 124.5,552C 120.609,544.694 122.942,541.528 131.5,542.5C 131.67,541.178 131.337,540.011 130.5,539C 128.1,538.814 125.766,538.314 123.5,537.5C 123.863,536.817 124.196,536.15 124.5,535.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#899495",
    d: "M 167.5,535.5 C 179.886,535.944 182.886,541.444 176.5,552C 173.854,552.497 171.187,552.664 168.5,552.5C 168.5,554.5 168.5,556.5 168.5,558.5C 167.5,558.5 166.5,558.5 165.5,558.5C 164.919,550.559 165.586,542.892 167.5,535.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#eec16d",
    d: "M 64.5,537.5 C 68.3047,537.643 69.9714,539.643 69.5,543.5C 69.9711,548.025 67.9711,550.359 63.5,550.5C 63.8588,552.766 63.1922,554.599 61.5,556C 58.8333,556.667 56.1667,556.667 53.5,556C 52.944,555.617 52.6107,555.117 52.5,554.5C 52.5,551.167 52.5,547.833 52.5,544.5C 55.8499,544.665 59.1832,544.498 62.5,544C 64.229,542.211 64.8957,540.044 64.5,537.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#242627",
    d: "M 143.5,538.5 C 145.467,538.261 147.301,538.594 149,539.5C 149.499,543.152 149.665,546.818 149.5,550.5C 141.368,549.715 139.368,545.715 143.5,538.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#848d96",
    d: "M 109.5,535.5 C 116.5,535.167 119.833,538.5 119.5,545.5C 115.833,545.5 112.167,545.5 108.5,545.5C 109.466,550.383 112.299,551.717 117,549.5C 117.483,550.448 117.649,551.448 117.5,552.5C 107.895,554.061 103.729,550.061 105,540.5C 106.634,538.938 108.134,537.271 109.5,535.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#202429",
    d: "M 110.5,538.5 C 113.95,537.756 115.616,539.09 115.5,542.5C 113.167,542.5 110.833,542.5 108.5,542.5C 108.527,540.801 109.194,539.467 110.5,538.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#22252b",
    d: "M 168.5,538.5 C 176.036,537.92 178.536,541.253 176,548.5C 173.925,550.648 171.592,550.982 169,549.5C 168.501,545.848 168.335,542.182 168.5,538.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#716345",
    d: "M 63.5,537.5 C 63.8333,537.5 64.1667,537.5 64.5,537.5C 64.8957,540.044 64.229,542.211 62.5,544C 59.1832,544.498 55.8499,544.665 52.5,544.5C 55.3054,543.681 58.3054,543.181 61.5,543C 63.1554,541.556 63.822,539.722 63.5,537.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#202426",
    d: "M 125.5,545.5 C 127.5,545.5 129.5,545.5 131.5,545.5C 131.5,547.167 131.5,548.833 131.5,550.5C 127.062,551.575 125.062,549.908 125.5,545.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#868c8f",
    d: "M 181.5,536.5 C 182.833,536.5 184.167,536.5 185.5,536.5C 186.356,540.57 187.523,544.57 189,548.5C 190,544.833 191,541.167 192,537.5C 193.011,536.663 194.178,536.33 195.5,536.5C 194.924,544.739 191.924,551.906 186.5,558C 184.866,558.494 183.199,558.66 181.5,558.5C 181.5,557.5 181.5,556.5 181.5,555.5C 183.199,555.66 184.866,555.494 186.5,555C 187.059,554.275 187.392,553.442 187.5,552.5C 185.49,547.151 183.49,541.817 181.5,536.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#66716e",
    d: "M 52.5,544.5 C 52.5,547.833 52.5,551.167 52.5,554.5C 51.5655,553.432 51.2322,552.099 51.5,550.5C 49.901,550.768 48.5676,550.434 47.5,549.5C 48.5,549.5 49.5,549.5 50.5,549.5C 50.1201,547.302 50.7868,545.635 52.5,544.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#889091",
    d: "M 157.5,548.5 C 160.5,548.167 161.833,549.5 161.5,552.5C 160.167,552.5 158.833,552.5 157.5,552.5C 157.5,551.167 157.5,549.833 157.5,548.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#36373c",
    d: "M -0.5,568.5 C 9.16667,568.5 18.8333,568.5 28.5,568.5C 28.5,586.167 28.5,603.833 28.5,621.5C 18.8333,621.5 9.16667,621.5 -0.5,621.5C -0.5,603.833 -0.5,586.167 -0.5,568.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#37373d",
    d: "M 30.5,568.5 C 152.5,568.5 274.5,568.5 396.5,568.5C 396.5,586.167 396.5,603.833 396.5,621.5C 274.5,621.5 152.5,621.5 30.5,621.5C 30.5,603.833 30.5,586.167 30.5,568.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8cd3f2",
    d: "M 63.5,589.5 C 63.822,591.722 63.1554,593.556 61.5,595C 58.3054,595.181 55.3054,595.681 52.5,596.5C 51.8333,596.5 51.5,596.833 51.5,597.5C 50.5655,598.568 50.2322,599.901 50.5,601.5C 48.0885,601.863 46.5885,600.863 46,598.5C 45.245,595.697 45.5783,593.03 47,590.5C 50.4106,589.707 53.9106,589.207 57.5,589C 55.5273,588.505 53.5273,588.338 51.5,588.5C 51.0807,584.42 52.914,582.42 57,582.5C 62.1388,582.142 64.3055,584.475 63.5,589.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#889094",
    d: "M 130.5,582.5 C 133.861,583.203 134.194,584.537 131.5,586.5C 129.358,585.563 129.024,584.23 130.5,582.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#47545e",
    d: "M 53.5,584.5 C 55.337,584.639 55.6704,585.306 54.5,586.5C 53.7025,586.043 53.3691,585.376 53.5,584.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#88949f",
    d: "M 137.5,584.5 C 138.5,584.5 139.5,584.5 140.5,584.5C 140.5,586.167 140.5,587.833 140.5,589.5C 148.5,590.167 148.5,590.833 140.5,591.5C 140.335,595.182 140.501,598.848 141,602.5C 143,603.833 145,603.833 147,602.5C 147.483,603.448 147.649,604.448 147.5,605.5C 144.813,605.664 142.146,605.497 139.5,605C 138.874,604.25 138.374,603.416 138,602.5C 137.501,596.509 137.334,590.509 137.5,584.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ebbe6d",
    d: "M 64.5,589.5 C 68.3047,589.643 69.9714,591.643 69.5,595.5C 69.9711,600.025 67.9711,602.359 63.5,602.5C 63.7852,604.288 63.4519,605.955 62.5,607.5C 53.2025,610.539 49.5358,607.206 51.5,597.5C 51.5,596.833 51.8333,596.5 52.5,596.5C 55.8499,596.665 59.1832,596.498 62.5,596C 64.229,594.211 64.8957,592.044 64.5,589.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8b9295",
    d: "M 92.5,589.5 C 93.675,589.281 94.675,589.614 95.5,590.5C 96.513,594.22 97.6796,597.886 99,601.5C 100.739,597.689 101.572,593.689 101.5,589.5C 102.833,589.5 104.167,589.5 105.5,589.5C 107.529,602.788 109.529,602.788 111.5,589.5C 112.5,589.5 113.5,589.5 114.5,589.5C 113.826,594.856 112.159,599.856 109.5,604.5C 108.5,605.833 107.5,605.833 106.5,604.5C 104.116,592.773 102.116,593.106 100.5,605.5C 99.0222,605.762 97.6888,605.429 96.5,604.5C 95.0077,599.53 93.6744,594.53 92.5,589.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#82868d",
    d: "M 120.5,588.5 C 122.527,588.338 124.527,588.505 126.5,589C 126.957,589.414 127.291,589.914 127.5,590.5C 125.604,591.466 123.604,591.799 121.5,591.5C 121.5,596.167 121.5,600.833 121.5,605.5C 120.167,605.5 118.833,605.5 117.5,605.5C 117.5,600.167 117.5,594.833 117.5,589.5C 118.791,589.737 119.791,589.404 120.5,588.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8290a0",
    d: "M 129.5,589.5 C 130.5,589.5 131.5,589.5 132.5,589.5C 132.5,594.833 132.5,600.167 132.5,605.5C 131.5,605.5 130.5,605.5 129.5,605.5C 129.5,600.167 129.5,594.833 129.5,589.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8e9395",
    d: "M 177.5,588.5 C 189.407,588.986 192.407,594.319 186.5,604.5C 183.916,605.393 181.249,605.726 178.5,605.5C 178.5,607.5 178.5,609.5 178.5,611.5C 177.5,611.5 176.5,611.5 175.5,611.5C 174.919,603.559 175.586,595.892 177.5,588.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3a3a43",
    d: "M 178.5,591.5 C 185.162,590.997 187.662,593.997 186,600.5C 184.214,603.362 181.881,604.028 179,602.5C 178.501,598.848 178.335,595.182 178.5,591.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#899096",
    d: "M 154.5,588.5 C 161.322,588.324 164.322,591.657 163.5,598.5C 159.818,598.335 156.152,598.501 152.5,599C 154.201,603.315 157.201,604.482 161.5,602.5C 162.386,603.325 162.719,604.325 162.5,605.5C 151.749,607.581 147.582,603.248 150,592.5C 151.397,590.93 152.897,589.596 154.5,588.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3d3b42",
    d: "M 154.5,591.5 C 157.278,591.022 159.278,592.022 160.5,594.5C 157.833,595.833 155.167,595.833 152.5,594.5C 153.193,593.482 153.859,592.482 154.5,591.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#837155",
    d: "M 63.5,589.5 C 63.8333,589.5 64.1667,589.5 64.5,589.5C 64.8957,592.044 64.229,594.211 62.5,596C 59.1832,596.498 55.8499,596.665 52.5,596.5C 55.3054,595.681 58.3054,595.181 61.5,595C 63.1554,593.556 63.822,591.722 63.5,589.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#898f93",
    d: "M 191.5,590.5 C 192.568,589.566 193.901,589.232 195.5,589.5C 198.077,605.356 200.077,605.356 201.5,589.5C 202.978,589.238 204.311,589.571 205.5,590.5C 204.155,596.366 202.322,602.033 200,607.5C 197.592,610.62 194.426,611.953 190.5,611.5C 190.5,610.5 190.5,609.5 190.5,608.5C 192.527,608.662 194.527,608.495 196.5,608C 197.059,607.275 197.392,606.442 197.5,605.5C 194.733,600.722 192.733,595.722 191.5,590.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#848f99",
    d: "M 167.5,601.5 C 168.5,601.5 169.5,601.5 170.5,601.5C 170.5,602.833 170.5,604.167 170.5,605.5C 169.167,605.5 167.833,605.5 166.5,605.5C 166.433,604.041 166.766,602.708 167.5,601.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1a2023",
    d: "M -0.5,621.5 C 9.16667,621.5 18.8333,621.5 28.5,621.5C 29.1667,621.5 29.8333,621.5 30.5,621.5C 152.5,621.5 274.5,621.5 396.5,621.5C 396.5,744.167 396.5,866.833 396.5,989.5C 264.167,989.5 131.833,989.5 -0.5,989.5C -0.5,866.833 -0.5,744.167 -0.5,621.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7dbab4",
    d: "M 23.5,633.5 C 33.1619,635.74 43.1619,636.907 53.5,637C 54,637.5 54.5,638 55,638.5C 55.6667,644.833 55.6667,651.167 55,657.5C 54.5,658 54,658.5 53.5,659C 43.5,659.667 33.5,659.667 23.5,659C 23,658.5 22.5,658 22,657.5C 21.3333,650.167 21.3333,642.833 22,635.5C 22.7172,634.956 23.2172,634.289 23.5,633.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#808d9d",
    d: "M 112.5,634.5 C 113.5,634.5 114.5,634.5 115.5,634.5C 115.334,641.508 115.5,648.508 116,655.5C 118.683,656.575 118.849,657.575 116.5,658.5C 114.971,658.471 113.804,657.804 113,656.5C 112.5,649.174 112.334,641.841 112.5,634.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7d868c",
    d: "M 104.5,635.5 C 106.346,635.222 107.68,635.889 108.5,637.5C 107.68,639.111 106.346,639.778 104.5,639.5C 104.5,638.167 104.5,636.833 104.5,635.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#919594",
    d: "M 92.5,637.5 C 93.5,637.5 94.5,637.5 95.5,637.5C 95.5,639.167 95.5,640.833 95.5,642.5C 103.5,643.167 103.5,643.833 95.5,644.5C 95.3347,648.182 95.5014,651.848 96,655.5C 97.6667,656.833 99.3333,656.833 101,655.5C 101.483,656.448 101.649,657.448 101.5,658.5C 99.1432,658.663 96.8098,658.497 94.5,658C 93.8742,657.25 93.3742,656.416 93,655.5C 92.5005,649.509 92.3338,643.509 92.5,637.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1b2225",
    d: "M 25.5,639.5 C 34.1667,639.5 42.8333,639.5 51.5,639.5C 51.5,644.833 51.5,650.167 51.5,655.5C 42.8333,655.5 34.1667,655.5 25.5,655.5C 25.5,650.167 25.5,644.833 25.5,639.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8d9594",
    d: "M 74.5,642.5 C 75.5,642.5 76.5,642.5 77.5,642.5C 77.3345,646.514 77.5012,650.514 78,654.5C 79.7889,656.229 81.9556,656.896 84.5,656.5C 84.5,651.833 84.5,647.167 84.5,642.5C 85.5,642.5 86.5,642.5 87.5,642.5C 87.5,647.833 87.5,653.167 87.5,658.5C 83.5633,658.793 79.73,658.46 76,657.5C 74.6746,652.599 74.1746,647.599 74.5,642.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7e8d9f",
    d: "M 104.5,642.5 C 105.5,642.5 106.5,642.5 107.5,642.5C 107.5,647.833 107.5,653.167 107.5,658.5C 106.5,658.5 105.5,658.5 104.5,658.5C 104.5,653.167 104.5,647.833 104.5,642.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#90908d",
    d: "M 108.5,687.5 C 109.5,687.5 110.5,687.5 111.5,687.5C 110.913,695.373 111.58,703.04 113.5,710.5C 111.994,711.747 110.494,711.747 109,710.5C 108.5,702.841 108.334,695.174 108.5,687.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8ad1f0",
    d: "M 63.5,695.5 C 63.822,697.722 63.1554,699.556 61.5,701C 58.3054,701.181 55.3054,701.681 52.5,702.5C 50.7868,703.635 50.1201,705.302 50.5,707.5C 49.5,707.5 48.5,707.5 47.5,707.5C 43.2193,697.611 46.5527,693.444 57.5,695C 55.5273,694.505 53.5273,694.338 51.5,694.5C 51.0807,690.42 52.914,688.42 57,688.5C 62.1388,688.142 64.3055,690.475 63.5,695.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#919293",
    d: "M 249.5,690.5 C 251.256,691.552 251.923,693.219 251.5,695.5C 253.924,695.192 256.257,695.526 258.5,696.5C 256.604,697.466 254.604,697.799 252.5,697.5C 252.335,701.182 252.501,704.848 253,708.5C 254.667,709.833 256.333,709.833 258,708.5C 258.483,709.448 258.649,710.448 258.5,711.5C 255.315,711.98 252.481,711.314 250,709.5C 249.5,703.175 249.334,696.842 249.5,690.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#2e4048",
    d: "M 53.5,690.5 C 55.337,690.639 55.6704,691.306 54.5,692.5C 53.7025,692.043 53.3691,691.376 53.5,690.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#919594",
    d: "M 148.5,690.5 C 149.5,690.5 150.5,690.5 151.5,690.5C 151.5,692.167 151.5,693.833 151.5,695.5C 159.5,696.167 159.5,696.833 151.5,697.5C 151.335,701.182 151.501,704.848 152,708.5C 153.667,709.833 155.333,709.833 157,708.5C 157.483,709.448 157.649,710.448 157.5,711.5C 155.143,711.663 152.81,711.497 150.5,711C 149.874,710.25 149.374,709.416 149,708.5C 148.501,702.509 148.334,696.509 148.5,690.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#899497",
    d: "M 205.5,690.5 C 206.5,690.5 207.5,690.5 208.5,690.5C 208.5,692.167 208.5,693.833 208.5,695.5C 216.5,696.167 216.5,696.833 208.5,697.5C 208.335,701.182 208.501,704.848 209,708.5C 210.796,709.767 212.629,709.767 214.5,708.5C 215.386,709.325 215.719,710.325 215.5,711.5C 211.993,712.006 208.826,711.34 206,709.5C 205.5,703.175 205.334,696.842 205.5,690.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#eec16d",
    d: "M 64.5,695.5 C 68.3047,695.643 69.9714,697.643 69.5,701.5C 69.9711,706.025 67.9711,708.359 63.5,708.5C 63.8588,710.766 63.1922,712.599 61.5,714C 58.8333,714.667 56.1667,714.667 53.5,714C 52.944,713.617 52.6107,713.117 52.5,712.5C 52.5,709.167 52.5,705.833 52.5,702.5C 55.8499,702.665 59.1832,702.498 62.5,702C 64.229,700.211 64.8957,698.044 64.5,695.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#848d93",
    d: "M 98.5,694.5 C 100.977,694.051 102.977,694.717 104.5,696.5C 97.1025,696.741 94.6025,700.407 97,707.5C 99.0749,709.648 101.408,709.982 104,708.5C 104.483,709.448 104.649,710.448 104.5,711.5C 95.3956,712.562 91.5623,708.562 93,699.5C 94.7297,697.598 96.563,695.931 98.5,694.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#87959b",
    d: "M 116.5,695.5 C 117.5,695.5 118.5,695.5 119.5,695.5C 119.335,699.182 119.501,702.848 120,706.5C 121.287,709.145 123.453,710.145 126.5,709.5C 126.5,704.833 126.5,700.167 126.5,695.5C 127.5,695.5 128.5,695.5 129.5,695.5C 129.5,700.833 129.5,706.167 129.5,711.5C 117.323,712.969 112.989,707.635 116.5,695.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#848f98",
    d: "M 136.5,694.5 C 138.792,694.244 140.959,694.577 143,695.5C 143.167,695.833 143.333,696.167 143.5,696.5C 134.747,697.803 134.413,699.97 142.5,703C 145.07,705.718 145.07,708.385 142.5,711C 139.518,711.498 136.518,711.665 133.5,711.5C 133.351,710.448 133.517,709.448 134,708.5C 136.064,709.591 138.231,709.758 140.5,709C 141.022,708.439 141.355,707.772 141.5,707C 138.914,705.348 136.414,703.515 134,701.5C 133.333,700.167 133.333,698.833 134,697.5C 135.045,696.627 135.878,695.627 136.5,694.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8c8e8c",
    d: "M 180.5,694.5 C 182.527,694.338 184.527,694.505 186.5,695C 186.957,695.414 187.291,695.914 187.5,696.5C 185.604,697.466 183.604,697.799 181.5,697.5C 181.5,702.167 181.5,706.833 181.5,711.5C 180.5,711.5 179.5,711.5 178.5,711.5C 177.955,705.537 178.621,699.87 180.5,694.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#889095",
    d: "M 237.5,694.5 C 240.157,694.162 242.49,694.829 244.5,696.5C 242.257,697.474 239.924,697.808 237.5,697.5C 237.297,699.39 237.963,700.89 239.5,702C 245.623,703.01 246.956,706.01 243.5,711C 240.518,711.498 237.518,711.665 234.5,711.5C 234.251,708.425 235.585,707.758 238.5,709.5C 240.319,709.658 241.652,708.991 242.5,707.5C 240.295,705.474 237.795,703.808 235,702.5C 233.837,699.029 234.67,696.362 237.5,694.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#848e96",
    d: "M 271.5,694.5 C 278.84,693.326 283.173,696.326 284.5,703.5C 283.49,710.495 279.49,713.162 272.5,711.5C 272.5,713.5 272.5,715.5 272.5,717.5C 271.5,717.5 270.5,717.5 269.5,717.5C 268.919,709.559 269.586,701.892 271.5,694.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#848d96",
    d: "M 164.5,694.5 C 171.5,694.167 174.833,697.5 174.5,704.5C 170.833,704.5 167.167,704.5 163.5,704.5C 164.466,709.383 167.299,710.717 172,708.5C 172.483,709.448 172.649,710.448 172.5,711.5C 162.895,713.061 158.729,709.061 160,699.5C 161.634,697.938 163.134,696.271 164.5,694.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#202429",
    d: "M 165.5,697.5 C 168.95,696.756 170.616,698.09 170.5,701.5C 168.167,701.5 165.833,701.5 163.5,701.5C 163.527,699.801 164.194,698.467 165.5,697.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#848d96",
    d: "M 221.5,694.5 C 228.5,694.167 231.833,697.5 231.5,704.5C 227.833,704.5 224.167,704.5 220.5,704.5C 221.466,709.383 224.299,710.717 229,708.5C 229.483,709.448 229.649,710.448 229.5,711.5C 219.895,713.061 215.729,709.061 217,699.5C 218.634,697.938 220.134,696.271 221.5,694.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#202429",
    d: "M 222.5,697.5 C 225.95,696.756 227.616,698.09 227.5,701.5C 225.167,701.5 222.833,701.5 220.5,701.5C 220.527,699.801 221.194,698.467 222.5,697.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#252629",
    d: "M 272.5,697.5 C 280.036,696.92 282.536,700.253 280,707.5C 277.925,709.648 275.592,709.982 273,708.5C 272.501,704.848 272.335,701.182 272.5,697.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#716345",
    d: "M 63.5,695.5 C 63.8333,695.5 64.1667,695.5 64.5,695.5C 64.8957,698.044 64.229,700.211 62.5,702C 59.1832,702.498 55.8499,702.665 52.5,702.5C 55.3054,701.681 58.3054,701.181 61.5,701C 63.1554,699.556 63.822,697.722 63.5,695.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#87898a",
    d: "M 286.5,695.5 C 287.675,695.281 288.675,695.614 289.5,696.5C 290.765,699.796 291.932,703.129 293,706.5C 294.466,703.269 295.633,699.935 296.5,696.5C 297.325,695.614 298.325,695.281 299.5,695.5C 298.72,702.887 296.387,709.72 292.5,716C 290.323,717.202 287.989,717.702 285.5,717.5C 285.5,716.5 285.5,715.5 285.5,714.5C 287.199,714.66 288.866,714.494 290.5,714C 291.081,713.107 291.415,712.107 291.5,711C 289.331,705.994 287.665,700.827 286.5,695.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#66716e",
    d: "M 52.5,702.5 C 52.5,705.833 52.5,709.167 52.5,712.5C 51.5655,711.432 51.2322,710.099 51.5,708.5C 49.901,708.768 48.5676,708.434 47.5,707.5C 48.5,707.5 49.5,707.5 50.5,707.5C 50.1201,705.302 50.7868,703.635 52.5,702.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#889091",
    d: "M 261.5,707.5 C 264.5,707.167 265.833,708.5 265.5,711.5C 264.167,711.5 262.833,711.5 261.5,711.5C 261.5,710.167 261.5,708.833 261.5,707.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7f858a",
    d: "M 187.5,714.5 C 192.833,714.5 198.167,714.5 203.5,714.5C 203.5,715.5 203.5,716.5 203.5,717.5C 198.167,717.5 192.833,717.5 187.5,717.5C 187.5,716.5 187.5,715.5 187.5,714.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8ad1f0",
    d: "M 63.5,747.5 C 63.822,749.722 63.1554,751.556 61.5,753C 58.3054,753.181 55.3054,753.681 52.5,754.5C 50.7868,755.635 50.1201,757.302 50.5,759.5C 49.5,759.5 48.5,759.5 47.5,759.5C 43.2193,749.611 46.5527,745.444 57.5,747C 55.5273,746.505 53.5273,746.338 51.5,746.5C 51.0807,742.42 52.914,740.42 57,740.5C 62.1388,740.142 64.3055,742.475 63.5,747.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#90908d",
    d: "M 108.5,740.5 C 109.5,740.5 110.5,740.5 111.5,740.5C 110.913,748.373 111.58,756.04 113.5,763.5C 111.994,764.747 110.494,764.747 109,763.5C 108.5,755.841 108.334,748.174 108.5,740.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#2e4048",
    d: "M 53.5,742.5 C 55.337,742.639 55.6704,743.306 54.5,744.5C 53.7025,744.043 53.3691,743.376 53.5,742.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#919594",
    d: "M 148.5,743.5 C 149.5,743.5 150.5,743.5 151.5,743.5C 151.5,745.167 151.5,746.833 151.5,748.5C 159.5,749.167 159.5,749.833 151.5,750.5C 151.335,754.182 151.501,757.848 152,761.5C 153.667,762.833 155.333,762.833 157,761.5C 157.483,762.448 157.649,763.448 157.5,764.5C 155.143,764.663 152.81,764.497 150.5,764C 149.874,763.25 149.374,762.416 149,761.5C 148.501,755.509 148.334,749.509 148.5,743.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#eec16d",
    d: "M 64.5,747.5 C 68.3047,747.643 69.9714,749.643 69.5,753.5C 69.9711,758.025 67.9711,760.359 63.5,760.5C 63.8588,762.766 63.1922,764.599 61.5,766C 58.8333,766.667 56.1667,766.667 53.5,766C 52.944,765.617 52.6107,765.117 52.5,764.5C 52.5,761.167 52.5,757.833 52.5,754.5C 55.8499,754.665 59.1832,754.498 62.5,754C 64.229,752.211 64.8957,750.044 64.5,747.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#848d93",
    d: "M 98.5,747.5 C 100.977,747.051 102.977,747.717 104.5,749.5C 97.1025,749.741 94.6025,753.407 97,760.5C 99.0749,762.648 101.408,762.982 104,761.5C 104.483,762.448 104.649,763.448 104.5,764.5C 95.3956,765.562 91.5623,761.562 93,752.5C 94.7297,750.598 96.563,748.931 98.5,747.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#87959b",
    d: "M 116.5,748.5 C 117.5,748.5 118.5,748.5 119.5,748.5C 119.335,752.182 119.501,755.848 120,759.5C 121.287,762.145 123.453,763.145 126.5,762.5C 126.5,757.833 126.5,753.167 126.5,748.5C 127.5,748.5 128.5,748.5 129.5,748.5C 129.5,753.833 129.5,759.167 129.5,764.5C 117.323,765.969 112.989,760.635 116.5,748.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#848f98",
    d: "M 136.5,747.5 C 138.792,747.244 140.959,747.577 143,748.5C 143.167,748.833 143.333,749.167 143.5,749.5C 134.747,750.803 134.413,752.97 142.5,756C 145.07,758.718 145.07,761.385 142.5,764C 139.518,764.498 136.518,764.665 133.5,764.5C 133.351,763.448 133.517,762.448 134,761.5C 136.064,762.591 138.231,762.758 140.5,762C 141.022,761.439 141.355,760.772 141.5,760C 138.914,758.348 136.414,756.515 134,754.5C 133.333,753.167 133.333,751.833 134,750.5C 135.045,749.627 135.878,748.627 136.5,747.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8c8e8c",
    d: "M 180.5,747.5 C 182.527,747.338 184.527,747.505 186.5,748C 186.957,748.414 187.291,748.914 187.5,749.5C 185.604,750.466 183.604,750.799 181.5,750.5C 181.5,755.167 181.5,759.833 181.5,764.5C 180.5,764.5 179.5,764.5 178.5,764.5C 177.955,758.537 178.621,752.87 180.5,747.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8c9191",
    d: "M 198.5,747.5 C 208.212,746.709 212.045,751.043 210,760.5C 207.409,764.048 203.909,765.382 199.5,764.5C 199.5,766.5 199.5,768.5 199.5,770.5C 198.5,770.5 197.5,770.5 196.5,770.5C 195.919,762.559 196.586,754.892 198.5,747.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#848d96",
    d: "M 164.5,747.5 C 171.5,747.167 174.833,750.5 174.5,757.5C 170.833,757.5 167.167,757.5 163.5,757.5C 164.466,762.383 167.299,763.717 172,761.5C 172.483,762.448 172.649,763.448 172.5,764.5C 162.895,766.061 158.729,762.061 160,752.5C 161.634,750.938 163.134,749.271 164.5,747.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#202429",
    d: "M 165.5,750.5 C 168.95,749.756 170.616,751.09 170.5,754.5C 168.167,754.5 165.833,754.5 163.5,754.5C 163.527,752.801 164.194,751.467 165.5,750.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1e242b",
    d: "M 199.5,750.5 C 206.162,749.997 208.662,752.997 207,759.5C 205.214,762.362 202.881,763.028 200,761.5C 199.501,757.848 199.335,754.182 199.5,750.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#716345",
    d: "M 63.5,747.5 C 63.8333,747.5 64.1667,747.5 64.5,747.5C 64.8957,750.044 64.229,752.211 62.5,754C 59.1832,754.498 55.8499,754.665 52.5,754.5C 55.3054,753.681 58.3054,753.181 61.5,753C 63.1554,751.556 63.822,749.722 63.5,747.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#66716e",
    d: "M 52.5,754.5 C 52.5,757.833 52.5,761.167 52.5,764.5C 51.5655,763.432 51.2322,762.099 51.5,760.5C 49.901,760.768 48.5676,760.434 47.5,759.5C 48.5,759.5 49.5,759.5 50.5,759.5C 50.1201,757.302 50.7868,755.635 52.5,754.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#888c8c",
    d: "M 212.5,749.5 C 213.568,748.566 214.901,748.232 216.5,748.5C 216.953,752.693 218.119,756.693 220,760.5C 221.275,756.511 222.442,752.511 223.5,748.5C 224.5,748.5 225.5,748.5 226.5,748.5C 225.363,754.741 223.53,760.741 221,766.5C 218.592,769.62 215.426,770.953 211.5,770.5C 211.5,769.5 211.5,768.5 211.5,767.5C 213.527,767.662 215.527,767.495 217.5,767C 218.059,766.275 218.392,765.442 218.5,764.5C 215.733,759.722 213.733,754.722 212.5,749.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#808c96",
    d: "M 188.5,760.5 C 189.5,760.5 190.5,760.5 191.5,760.5C 191.5,761.833 191.5,763.167 191.5,764.5C 190.167,764.5 188.833,764.5 187.5,764.5C 187.433,763.041 187.766,761.708 188.5,760.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8ad1f0",
    d: "M 63.5,801.5 C 63.822,803.722 63.1554,805.556 61.5,807C 58.3054,807.181 55.3054,807.681 52.5,808.5C 50.7868,809.635 50.1201,811.302 50.5,813.5C 49.5,813.5 48.5,813.5 47.5,813.5C 43.2193,803.611 46.5527,799.444 57.5,801C 55.5273,800.505 53.5273,800.338 51.5,800.5C 51.0807,796.42 52.914,794.42 57,794.5C 62.1388,794.142 64.3055,796.475 63.5,801.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#86929e",
    d: "M 191.5,795.5 C 192.5,795.5 193.5,795.5 194.5,795.5C 194.5,797.167 194.5,798.833 194.5,800.5C 202.5,801.167 202.5,801.833 194.5,802.5C 194.335,806.182 194.501,809.848 195,813.5C 197,814.833 199,814.833 201,813.5C 201.483,814.448 201.649,815.448 201.5,816.5C 198.813,816.664 196.146,816.497 193.5,816C 192.874,815.25 192.374,814.416 192,813.5C 191.501,807.509 191.334,801.509 191.5,795.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#2e4048",
    d: "M 53.5,796.5 C 55.337,796.639 55.6704,797.306 54.5,798.5C 53.7025,798.043 53.3691,797.376 53.5,796.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#828c96",
    d: "M 98.5,799.5 C 100.92,799.292 103.253,799.626 105.5,800.5C 106.664,806.472 106.83,812.472 106,818.5C 105.5,820.333 104.333,821.5 102.5,822C 99.8333,822.667 97.1667,822.667 94.5,822C 94.0426,821.586 93.7093,821.086 93.5,820.5C 96.4465,819.679 99.4465,819.179 102.5,819C 103.337,817.989 103.67,816.822 103.5,815.5C 95.3454,816.18 91.8454,812.514 93,804.5C 94.7297,802.598 96.563,800.931 98.5,799.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#899397",
    d: "M 133.5,799.5 C 142.192,799.701 145.359,804.035 143,812.5C 137.833,818.092 133.167,817.759 129,811.5C 127.309,806.131 128.809,802.131 133.5,799.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#848f96",
    d: "M 149.5,799.5 C 152.807,799.063 155.807,799.73 158.5,801.5C 161.906,798.941 165.24,798.941 168.5,801.5C 169.494,806.456 169.827,811.456 169.5,816.5C 168.5,816.5 167.5,816.5 166.5,816.5C 166.666,812.154 166.499,807.821 166,803.5C 164.301,802.594 162.467,802.261 160.5,802.5C 160.5,807.167 160.5,811.833 160.5,816.5C 159.5,816.5 158.5,816.5 157.5,816.5C 157.666,812.486 157.499,808.486 157,804.5C 155.211,802.771 153.044,802.104 150.5,802.5C 150.5,807.167 150.5,811.833 150.5,816.5C 149.5,816.5 148.5,816.5 147.5,816.5C 146.955,810.537 147.621,804.87 149.5,799.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#838c92",
    d: "M 178.5,799.5 C 185.714,799.047 188.714,802.38 187.5,809.5C 184.167,809.5 180.833,809.5 177.5,809.5C 178.466,814.383 181.299,815.717 186,813.5C 186.483,814.448 186.649,815.448 186.5,816.5C 176.342,817.843 172.175,813.51 174,803.5C 175.397,801.93 176.897,800.596 178.5,799.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#879393",
    d: "M 206.5,799.5 C 208.527,799.338 210.527,799.505 212.5,800C 212.957,800.414 213.291,800.914 213.5,801.5C 211.604,802.466 209.604,802.799 207.5,802.5C 207.5,807.167 207.5,811.833 207.5,816.5C 206.5,816.5 205.5,816.5 204.5,816.5C 203.955,810.537 204.621,804.87 206.5,799.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8c9191",
    d: "M 242.5,799.5 C 252.212,798.709 256.045,803.043 254,812.5C 251.409,816.048 247.909,817.382 243.5,816.5C 243.5,818.5 243.5,820.5 243.5,822.5C 242.5,822.5 241.5,822.5 240.5,822.5C 239.919,814.559 240.586,806.892 242.5,799.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#eec16d",
    d: "M 64.5,801.5 C 68.3047,801.643 69.9714,803.643 69.5,807.5C 69.9711,812.025 67.9711,814.359 63.5,814.5C 63.8588,816.766 63.1922,818.599 61.5,820C 58.8333,820.667 56.1667,820.667 53.5,820C 52.944,819.617 52.6107,819.117 52.5,818.5C 52.5,815.167 52.5,811.833 52.5,808.5C 55.8499,808.665 59.1832,808.498 62.5,808C 64.229,806.211 64.8957,804.044 64.5,801.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1e2225",
    d: "M 98.5,802.5 C 100.167,802.5 101.833,802.5 103.5,802.5C 103.665,805.85 103.498,809.183 103,812.5C 100.733,813.935 98.7328,813.602 97,811.5C 96.068,808.177 96.568,805.177 98.5,802.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#24262b",
    d: "M 133.5,802.5 C 140.03,802.243 142.197,805.243 140,811.5C 137.633,814.932 134.966,815.265 132,812.5C 131.037,808.851 131.537,805.518 133.5,802.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1f2227",
    d: "M 178.5,802.5 C 181.278,802.022 183.278,803.022 184.5,805.5C 182.257,806.474 179.924,806.808 177.5,806.5C 177.433,805.041 177.766,803.708 178.5,802.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#848d96",
    d: "M 115.5,799.5 C 122.5,799.167 125.833,802.5 125.5,809.5C 121.833,809.5 118.167,809.5 114.5,809.5C 115.466,814.383 118.299,815.717 123,813.5C 123.483,814.448 123.649,815.448 123.5,816.5C 113.895,818.061 109.729,814.061 111,804.5C 112.634,802.938 114.134,801.271 115.5,799.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#202429",
    d: "M 116.5,802.5 C 119.95,801.756 121.616,803.09 121.5,806.5C 119.167,806.5 116.833,806.5 114.5,806.5C 114.527,804.801 115.194,803.467 116.5,802.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1e242b",
    d: "M 243.5,802.5 C 250.162,801.997 252.662,804.997 251,811.5C 249.214,814.362 246.881,815.028 244,813.5C 243.501,809.848 243.335,806.182 243.5,802.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#716345",
    d: "M 63.5,801.5 C 63.8333,801.5 64.1667,801.5 64.5,801.5C 64.8957,804.044 64.229,806.211 62.5,808C 59.1832,808.498 55.8499,808.665 52.5,808.5C 55.3054,807.681 58.3054,807.181 61.5,807C 63.1554,805.556 63.822,803.722 63.5,801.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#888c8c",
    d: "M 215.5,801.5 C 216.568,800.566 217.901,800.232 219.5,800.5C 219.953,804.693 221.119,808.693 223,812.5C 224.275,808.511 225.442,804.511 226.5,800.5C 227.5,800.5 228.5,800.5 229.5,800.5C 228.363,806.741 226.53,812.741 224,818.5C 221.592,821.62 218.426,822.953 214.5,822.5C 214.5,821.5 214.5,820.5 214.5,819.5C 216.527,819.662 218.527,819.495 220.5,819C 221.059,818.275 221.392,817.442 221.5,816.5C 218.733,811.722 216.733,806.722 215.5,801.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#888c8c",
    d: "M 256.5,801.5 C 257.568,800.566 258.901,800.232 260.5,800.5C 260.953,804.693 262.119,808.693 264,812.5C 265.275,808.511 266.442,804.511 267.5,800.5C 268.5,800.5 269.5,800.5 270.5,800.5C 269.363,806.741 267.53,812.741 265,818.5C 262.592,821.62 259.426,822.953 255.5,822.5C 255.5,821.5 255.5,820.5 255.5,819.5C 257.527,819.662 259.527,819.495 261.5,819C 262.059,818.275 262.392,817.442 262.5,816.5C 259.733,811.722 257.733,806.722 256.5,801.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#66716e",
    d: "M 52.5,808.5 C 52.5,811.833 52.5,815.167 52.5,818.5C 51.5655,817.432 51.2322,816.099 51.5,814.5C 49.901,814.768 48.5676,814.434 47.5,813.5C 48.5,813.5 49.5,813.5 50.5,813.5C 50.1201,811.302 50.7868,809.635 52.5,808.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#898b8b",
    d: "M 232.5,812.5 C 235.5,812.167 236.833,813.5 236.5,816.5C 235.167,816.5 233.833,816.5 232.5,816.5C 232.5,815.167 232.5,813.833 232.5,812.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ed8286",
    d: "M 36.5,844.5 C 37.552,844.351 38.552,844.517 39.5,845C 44.2135,849.378 48.5468,854.044 52.5,859C 48.8808,863.622 44.8808,867.955 40.5,872C 39.5,872.667 38.5,872.667 37.5,872C 32.7865,867.622 28.4532,862.956 24.5,858C 26.7738,853.697 30.1071,851.031 34.5,850C 35.8932,851.171 36.7265,852.671 37,854.5C 37.6067,858.537 37.44,862.537 36.5,866.5C 37.8333,866.5 39.1667,866.5 40.5,866.5C 39.588,862.869 39.4213,859.203 40,855.5C 41.883,856.653 42.7163,858.319 42.5,860.5C 43.8333,860.5 45.1667,860.5 46.5,860.5C 46.6495,859.448 46.4828,858.448 46,857.5C 42.4454,854.698 39.1121,851.698 36,848.5C 35.4209,847.072 35.5876,845.738 36.5,844.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#787978",
    d: "M 100.5,846.5 C 101.5,846.5 102.5,846.5 103.5,846.5C 103.5,847.833 103.5,849.167 103.5,850.5C 100.046,850.733 99.0464,849.4 100.5,846.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7a7772",
    d: "M 120.5,846.5 C 122.346,846.222 123.68,846.889 124.5,848.5C 123.68,850.111 122.346,850.778 120.5,850.5C 120.5,849.167 120.5,847.833 120.5,846.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#888079",
    d: "M 108.5,848.5 C 109.5,848.5 110.5,848.5 111.5,848.5C 111.5,850.167 111.5,851.833 111.5,853.5C 119.5,854.167 119.5,854.833 111.5,855.5C 111.335,859.182 111.501,862.848 112,866.5C 113.667,867.833 115.333,867.833 117,866.5C 117.483,867.448 117.649,868.448 117.5,869.5C 114.315,869.98 111.481,869.314 109,867.5C 108.5,861.175 108.334,854.842 108.5,848.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#82827e",
    d: "M 86.5,852.5 C 89.5448,852.508 92.5448,852.841 95.5,853.5C 95.9204,860.284 95.4204,866.95 94,873.5C 90.3797,875.183 86.5463,875.85 82.5,875.5C 82.5,874.5 82.5,873.5 82.5,872.5C 85.5184,872.665 88.5184,872.498 91.5,872C 92.3366,870.989 92.67,869.822 92.5,868.5C 83.2492,869.7 79.7492,865.7 82,856.5C 83.3968,854.93 84.8968,853.596 86.5,852.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#898279",
    d: "M 100.5,853.5 C 101.5,853.5 102.5,853.5 103.5,853.5C 103.5,858.833 103.5,864.167 103.5,869.5C 102.5,869.5 101.5,869.5 100.5,869.5C 100.5,864.167 100.5,858.833 100.5,853.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7d8587",
    d: "M 120.5,853.5 C 121.5,853.5 122.5,853.5 123.5,853.5C 123.5,858.833 123.5,864.167 123.5,869.5C 122.5,869.5 121.5,869.5 120.5,869.5C 120.5,864.167 120.5,858.833 120.5,853.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7e8180",
    d: "M 132.5,852.5 C 135.545,852.508 138.545,852.841 141.5,853.5C 141.666,859.842 141.5,866.175 141,872.5C 137.662,875.318 133.829,876.151 129.5,875C 129.043,874.586 128.709,874.086 128.5,873.5C 131.447,872.679 134.447,872.179 137.5,872C 138.337,870.989 138.67,869.822 138.5,868.5C 129.724,869.33 126.224,865.33 128,856.5C 129.667,855.267 131.167,853.933 132.5,852.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7f837f",
    d: "M 148.5,852.5 C 152.516,851.9 156.016,852.9 159,855.5C 159.499,860.155 159.666,864.821 159.5,869.5C 158.5,869.5 157.5,869.5 156.5,869.5C 156.666,865.486 156.499,861.486 156,857.5C 154.211,855.771 152.044,855.104 149.5,855.5C 149.5,860.167 149.5,864.833 149.5,869.5C 148.5,869.5 147.5,869.5 146.5,869.5C 145.955,863.537 146.621,857.87 148.5,852.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#827972",
    d: "M 185.5,852.5 C 187.527,852.338 189.527,852.505 191.5,853C 191.957,853.414 192.291,853.914 192.5,854.5C 190.604,855.466 188.604,855.799 186.5,855.5C 186.5,860.167 186.5,864.833 186.5,869.5C 185.5,869.5 184.5,869.5 183.5,869.5C 182.955,863.537 183.621,857.87 185.5,852.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7f7e7c",
    d: "M 199.5,852.5 C 205.983,852.651 208.983,855.984 208.5,862.5C 204.774,862.177 201.107,862.511 197.5,863.5C 199.325,867.543 202.325,868.543 206.5,866.5C 207.386,867.325 207.719,868.325 207.5,869.5C 196.727,871.56 192.56,867.227 195,856.5C 196.397,854.93 197.897,853.596 199.5,852.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#23252a",
    d: "M 86.5,855.5 C 88.5,855.5 90.5,855.5 92.5,855.5C 92.8204,858.898 92.487,862.232 91.5,865.5C 88.5272,867.218 86.3605,866.551 85,863.5C 84.1093,860.502 84.6093,857.836 86.5,855.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#222427",
    d: "M 133.5,855.5 C 135.167,855.5 136.833,855.5 138.5,855.5C 138.665,858.85 138.498,862.183 138,865.5C 133.602,866.961 131.102,865.294 130.5,860.5C 130.771,858.307 131.771,856.641 133.5,855.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1f2226",
    d: "M 199.5,855.5 C 202.95,854.756 204.616,856.09 204.5,859.5C 202.076,859.808 199.743,859.474 197.5,858.5C 198.193,857.482 198.859,856.482 199.5,855.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7e7f7f",
    d: "M 168.5,852.5 C 175.985,852.483 179.485,856.15 179,863.5C 177.171,869.158 173.337,870.992 167.5,869C 163.673,865.692 162.506,861.526 164,856.5C 165.667,855.267 167.167,853.933 168.5,852.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#232529",
    d: "M 169.5,855.5 C 171.722,855.178 173.556,855.845 175,857.5C 176.004,860.993 175.504,864.159 173.5,867C 169.07,867.576 166.736,865.576 166.5,861C 166.685,858.624 167.685,856.791 169.5,855.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#797d80",
    d: "M 74.5,865.5 C 75.5,865.5 76.5,865.5 77.5,865.5C 77.5,866.833 77.5,868.167 77.5,869.5C 76.1667,869.5 74.8333,869.5 73.5,869.5C 73.4326,868.041 73.7659,866.708 74.5,865.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#798f9a",
    d: "M 25.5,897.5 C 34.1667,897.5 42.8333,897.5 51.5,897.5C 51.5,903.833 51.5,910.167 51.5,916.5C 48.1667,916.5 44.8333,916.5 41.5,916.5C 41.5,919.5 41.5,922.5 41.5,925.5C 36.1667,925.5 30.8333,925.5 25.5,925.5C 25.5,916.167 25.5,906.833 25.5,897.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#808f9d",
    d: "M 84.5,898.5 C 85.5,898.5 86.5,898.5 87.5,898.5C 87.5,906.5 87.5,914.5 87.5,922.5C 76.8447,924.343 72.3447,920.01 74,909.5C 76.6267,905.847 79.9601,904.847 84,906.5C 84.4974,903.854 84.6641,901.187 84.5,898.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8d9191",
    d: "M 110.5,898.5 C 111.5,898.5 112.5,898.5 113.5,898.5C 113.336,901.187 113.503,903.854 114,906.5C 122.913,905.431 126.246,909.431 124,918.5C 120.349,922.205 115.849,923.539 110.5,922.5C 110.5,914.5 110.5,906.5 110.5,898.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#90908d",
    d: "M 172.5,898.5 C 173.5,898.5 174.5,898.5 175.5,898.5C 174.913,906.373 175.58,914.04 177.5,921.5C 175.994,922.747 174.494,922.747 173,921.5C 172.5,913.841 172.334,906.174 172.5,898.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#868e94",
    d: "M 97.5,905.5 C 104.032,905.697 107.032,909.031 106.5,915.5C 102.774,915.177 99.1073,915.511 95.5,916.5C 96.9597,920.468 99.6264,921.468 103.5,919.5C 104.386,920.325 104.719,921.325 104.5,922.5C 94.2471,924.033 90.4137,919.699 93,909.5C 94.3968,907.93 95.8968,906.596 97.5,905.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#87959b",
    d: "M 128.5,906.5 C 129.5,906.5 130.5,906.5 131.5,906.5C 131.335,910.182 131.501,913.848 132,917.5C 133.287,920.145 135.453,921.145 138.5,920.5C 138.5,915.833 138.5,911.167 138.5,906.5C 139.5,906.5 140.5,906.5 141.5,906.5C 141.5,911.833 141.5,917.167 141.5,922.5C 129.323,923.969 124.989,918.635 128.5,906.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#828c96",
    d: "M 151.5,905.5 C 153.92,905.292 156.253,905.626 158.5,906.5C 159.664,912.472 159.83,918.472 159,924.5C 158.5,926.333 157.333,927.5 155.5,928C 152.833,928.667 150.167,928.667 147.5,928C 147.043,927.586 146.709,927.086 146.5,926.5C 149.447,925.679 152.447,925.179 155.5,925C 156.337,923.989 156.67,922.822 156.5,921.5C 148.345,922.18 144.845,918.514 146,910.5C 147.73,908.598 149.563,906.931 151.5,905.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#848a90",
    d: "M 185.5,905.5 C 192.95,906.116 196.117,910.116 195,917.5C 192.565,922.224 188.731,923.724 183.5,922C 177.741,915.568 178.408,910.068 185.5,905.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#889094",
    d: "M 203.5,905.5 C 206.545,905.508 209.545,905.841 212.5,906.5C 212.92,913.284 212.42,919.95 211,926.5C 207.38,928.183 203.546,928.85 199.5,928.5C 199.5,927.5 199.5,926.5 199.5,925.5C 202.187,925.664 204.854,925.497 207.5,925C 208.337,923.989 208.67,922.822 208.5,921.5C 199.923,922.065 196.756,918.065 199,909.5C 200.397,907.93 201.897,906.596 203.5,905.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#242627",
    d: "M 78.5,908.5 C 80.4672,908.261 82.3005,908.594 84,909.5C 84.4986,913.152 84.6653,916.818 84.5,920.5C 76.3682,919.715 74.3682,915.715 78.5,908.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#242528",
    d: "M 97.5,908.5 C 100.95,907.756 102.616,909.09 102.5,912.5C 100.167,912.5 97.8333,912.5 95.5,912.5C 95.5271,910.801 96.1938,909.467 97.5,908.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1e242b",
    d: "M 114.5,908.5 C 121.03,908.243 123.197,911.243 121,917.5C 119.152,920.041 116.652,921.041 113.5,920.5C 113.237,916.4 113.57,912.4 114.5,908.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1e2225",
    d: "M 151.5,908.5 C 153.167,908.5 154.833,908.5 156.5,908.5C 156.665,911.85 156.498,915.183 156,918.5C 153.733,919.935 151.733,919.602 150,917.5C 149.068,914.177 149.568,911.177 151.5,908.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1f2328",
    d: "M 185.5,908.5 C 187.722,908.178 189.556,908.845 191,910.5C 192.004,913.993 191.504,917.159 189.5,920C 187.299,920.825 185.466,920.325 184,918.5C 183.037,914.851 183.537,911.518 185.5,908.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#24272d",
    d: "M 203.5,908.5 C 205.5,908.5 207.5,908.5 209.5,908.5C 209.665,911.85 209.498,915.183 209,918.5C 205.914,920.22 203.581,919.553 202,916.5C 201.109,913.502 201.609,910.836 203.5,908.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7bc0df",
    d: "M 44.5,918.5 C 46.5273,918.338 48.5273,918.505 50.5,919C 48.6667,920.833 46.8333,922.667 45,924.5C 44.5045,922.527 44.3379,920.527 44.5,918.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#898b8b",
    d: "M 164.5,918.5 C 167.5,918.167 168.833,919.5 168.5,922.5C 167.167,922.5 165.833,922.5 164.5,922.5C 164.5,921.167 164.5,919.833 164.5,918.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8ad1f0",
    d: "M 44.5,959.5 C 44.822,961.722 44.1554,963.556 42.5,965C 39.3054,965.181 36.3054,965.681 33.5,966.5C 31.7868,967.635 31.1201,969.302 31.5,971.5C 30.5,971.5 29.5,971.5 28.5,971.5C 24.2193,961.611 27.5527,957.444 38.5,959C 36.5273,958.505 34.5273,958.338 32.5,958.5C 32.0807,954.42 33.914,952.42 38,952.5C 43.1388,952.142 45.3055,954.475 44.5,959.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#858786",
    d: "M 117.5,952.5 C 119.346,952.222 120.68,952.889 121.5,954.5C 120.68,956.111 119.346,956.778 117.5,956.5C 117.5,955.167 117.5,953.833 117.5,952.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#2e4048",
    d: "M 34.5,954.5 C 36.337,954.639 36.6704,955.306 35.5,956.5C 34.7025,956.043 34.3691,955.376 34.5,954.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#eec16d",
    d: "M 45.5,959.5 C 49.3047,959.643 50.9714,961.643 50.5,965.5C 50.9711,970.025 48.9711,972.359 44.5,972.5C 44.8588,974.766 44.1922,976.599 42.5,978C 39.8333,978.667 37.1667,978.667 34.5,978C 33.944,977.617 33.6107,977.117 33.5,976.5C 33.5,973.167 33.5,969.833 33.5,966.5C 36.8499,966.665 40.1832,966.498 43.5,966C 45.229,964.211 45.8957,962.044 45.5,959.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#838c90",
    d: "M 76.5,958.5 C 79.6852,958.02 82.5185,958.686 85,960.5C 88.9364,957.686 92.6031,958.019 96,961.5C 96.4992,966.155 96.6658,970.821 96.5,975.5C 95.5,975.5 94.5,975.5 93.5,975.5C 93.8256,971.116 93.4922,966.783 92.5,962.5C 90.9291,961.691 89.2624,961.357 87.5,961.5C 87.5,966.167 87.5,970.833 87.5,975.5C 86.1667,975.5 84.8333,975.5 83.5,975.5C 83.6657,971.154 83.499,966.821 83,962.5C 81.3005,961.594 79.4672,961.261 77.5,961.5C 77.5,966.167 77.5,970.833 77.5,975.5C 76.5,975.5 75.5,975.5 74.5,975.5C 73.9546,969.537 74.6213,963.87 76.5,958.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#868b8f",
    d: "M 102.5,958.5 C 106.401,957.857 109.734,958.857 112.5,961.5C 113.443,966.1 113.777,970.767 113.5,975.5C 109.818,975.665 106.152,975.499 102.5,975C 98.6091,967.694 100.942,964.528 109.5,965.5C 109.67,964.178 109.337,963.011 108.5,962C 106.527,961.505 104.527,961.338 102.5,961.5C 102.5,960.5 102.5,959.5 102.5,958.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#859498",
    d: "M 117.5,959.5 C 118.5,959.5 119.5,959.5 120.5,959.5C 120.5,964.833 120.5,970.167 120.5,975.5C 119.5,975.5 118.5,975.5 117.5,975.5C 117.5,970.167 117.5,964.833 117.5,959.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#869395",
    d: "M 127.5,958.5 C 131.516,957.9 135.016,958.9 138,961.5C 138.499,966.155 138.666,970.821 138.5,975.5C 137.5,975.5 136.5,975.5 135.5,975.5C 135.666,971.486 135.499,967.486 135,963.5C 133.211,961.771 131.044,961.104 128.5,961.5C 128.5,966.167 128.5,970.833 128.5,975.5C 127.5,975.5 126.5,975.5 125.5,975.5C 124.955,969.537 125.621,963.87 127.5,958.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8c9191",
    d: "M 153.5,958.5 C 163.212,957.709 167.045,962.043 165,971.5C 162.409,975.048 158.909,976.382 154.5,975.5C 154.5,977.5 154.5,979.5 154.5,981.5C 153.5,981.5 152.5,981.5 151.5,981.5C 150.919,973.559 151.586,965.892 153.5,958.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1e242b",
    d: "M 154.5,961.5 C 161.162,960.997 163.662,963.997 162,970.5C 160.214,973.362 157.881,974.028 155,972.5C 154.501,968.848 154.335,965.182 154.5,961.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#716345",
    d: "M 44.5,959.5 C 44.8333,959.5 45.1667,959.5 45.5,959.5C 45.8957,962.044 45.229,964.211 43.5,966C 40.1832,966.498 36.8499,966.665 33.5,966.5C 36.3054,965.681 39.3054,965.181 42.5,965C 44.1554,963.556 44.822,961.722 44.5,959.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#25282d",
    d: "M 103.5,968.5 C 105.833,968.5 108.167,968.5 110.5,968.5C 110.5,970.167 110.5,971.833 110.5,973.5C 108.473,973.662 106.473,973.495 104.5,973C 103.62,971.644 103.286,970.144 103.5,968.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#66716e",
    d: "M 33.5,966.5 C 33.5,969.833 33.5,973.167 33.5,976.5C 32.5655,975.432 32.2322,974.099 32.5,972.5C 30.901,972.768 29.5676,972.434 28.5,971.5C 29.5,971.5 30.5,971.5 31.5,971.5C 31.1201,969.302 31.7868,967.635 33.5,966.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#858a8c",
    d: "M 167.5,959.5 C 168.822,959.33 169.989,959.663 171,960.5C 174.398,975.119 176.564,974.785 177.5,959.5C 178.833,959.5 180.167,959.5 181.5,959.5C 180.081,966.591 177.581,973.258 174,979.5C 171.772,981.113 169.272,981.78 166.5,981.5C 166.5,980.5 166.5,979.5 166.5,978.5C 169.596,979.093 171.929,978.093 173.5,975.5C 170.895,970.427 168.895,965.094 167.5,959.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#808c96",
    d: "M 143.5,971.5 C 144.5,971.5 145.5,971.5 146.5,971.5C 146.5,972.833 146.5,974.167 146.5,975.5C 145.167,975.5 143.833,975.5 142.5,975.5C 142.433,974.041 142.766,972.708 143.5,971.5 Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.fcb42962e28405a448592d90c291a46f.svg";
export { ForwardRef as ReactComponent };